<template>
    <Portal id="online-training-portal" :style="{'touch-action': (isTouchDevice && (!readyForVideoStream || !isLandscapeOrientation)) ? 'pan-y' : 'auto'}">
        <template v-if="(store.myUser.onlineTrainingAllowTwoDeviceSetup && !deviceMode) && isLandscapeOrientation">
            <CRow class="justify-content-center mt-5 mb-3">
                <h4>Select device mode:</h4>
            </CRow>
            <CRow class="justify-content-center mt-3 mb-3">
                <CButton
                    @click.prevent="deviceMode = 'display'"
                    color="primary"
                    shape="pill"
                >
                    Display device
                </CButton>
            </CRow>
            <CRow class="justify-content-center mt-3 mb-3">
                <CButton
                    @click.prevent="deviceMode = 'camera'"
                    color="primary"
                    shape="pill"
                >
                    Camera device
                </CButton>
            </CRow>
            <CRow class="justify-content-center mt-3 mb-3">
                <CButton
                    @click.prevent="deviceMode = 'camera_and_display'"
                    color="primary"
                    shape="pill"
                >
                    Display and camera device
                </CButton>
            </CRow>
        </template>
        <template v-if="!store.myUser.onlineTrainingAllowTwoDeviceSetup || (deviceMode && isDisplayDevice) || (trainingStarted && deviceMode === 'camera')">
            <template v-if="!trainingStarted && isLandscapeOrientation && store.myUser.onlineTrainingInvestorViewFlag">
                <CRow class="d-flex justify-content-center align-items-center mb-1"><h5><b>Select connected activity:</b></h5></CRow>

                <CRow class="d-flex justify-content-center align-items-center mb-1">
                    <!--suppress HtmlRequiredAltAttribute -->
                    <img height="34" src="../assets/img/squats.svg" style="color: black; margin: 0 27px 0 0"/>
                    <img src="../assets/img/cycling.svg" alt="" height="36">
                    <!--suppress HtmlUnknownTag -->
                    <CIcon name="cilRowing" height="37" style="color: black; margin: 0 27px 0 27px"/>
                    <img src="../assets/img/gym-workout-treadmill.svg" alt="" height="34">
                </CRow>
                <CRow class="d-flex justify-content-center align-items-center mb-4">
                    <CInputRadioGroup
                        class="d-flex flex-wrap activity-radio"
                        custom
                        :options="[
                                                                {value: 'crossfit', label: ' '},
                                                                {value: 'ride', label: '    '},
                                                                {value: 'rowing', label: '     '} ,
                                                                {value: 'run', label: ' '},
                                                                ]"
                        :checked.sync="trainingMode"
                    />
                </CRow>
            </template>
            <CRow v-if="isLandscapeOrientation" class="d-flex justify-content-center align-items-center mb-4">
                <CButton
                    :style ="{visibility: rowingIsFullscreenFlag ? 'hidden' : 'visible' }"
                    @click.prevent="startStopTraining"
                    :color="trainingStarted ? 'info' : 'success'"
                    :disabled="this.startStopButtonDisabled ||
                (store.myUser.onlineTrainingInvestorViewFlag && (trainingMode !== 'rowing' && trainingMode !== 'crossfit') && !this.trainingStarted)"
                    id="start-stop-button"
                >
                    <template v-if="trainingMode === 'rowing' || trainingMode === 'crossfit' || deviceMode === 'camera'">
                        {{ trainingStarted ? 'Stop real-time analysis' : 'Start real-time analysis (beta)' }}
                    </template>
                    <template v-else>
                        In development
                    </template>
                </CButton>
            </CRow>
        </template>
        <CRow v-if="(!trainingStarted && isLandscapeOrientation && (deviceMode === 'camera' || deviceMode === 'camera_and_display'))" class="justify-content-center align-items-center pl-3 pr-3" style="margin-top: 30px">
            <h5><template v-if="deviceMode === 'camera_and_display'">1. </template>Please set the camera so that the athlete is in a lateral position and totally in frame with all body parts like arms, elbows, shins, head while rowing.</h5>
        </CRow>
        <CRow v-if="!trainingStarted && isLandscapeOrientation && deviceMode === 'camera_and_display'" class="justify-content-center align-items-center online-training-bottom-text pl-3 pr-3 mb-5">
            <h5>2. It is recommended to connect a monitor or TV in front of you by wire (wireless casting may introduce up to a 1-second delay).</h5>
        </CRow>
        <template v-if="!isLandscapeOrientation">
            <CRow class="justify-content-center align-items-center mb-4 mt-4 pl-3 pr-3">
                <h4>Please rotate your device to landscape orientation</h4>
            </CRow>
            <CRow class="justify-content-center align-items-center mt-2 pl-3 pr-3 mb-5">
                <img src="../assets/img/mobile-landscape-mode.svg" alt="" height="136">
            </CRow>
        </template>
        <div v-if="trainingStarted" :style="{display: isLandscapeOrientation ? 'block' : 'none'}">
            <CRow v-if="errorText" class="d-flex justify-content-center align-items-center mb-10 mt-10">
                <h4>{{ errorText }}</h4>
            </CRow>
            <div v-else-if="trainingMode==='crossfit' && crossfitTrainingConfig === null">
                <CRow class="justify-content-center mt-5 mb-3">
                    <h4>Select training plan:</h4>
                </CRow>
                <CRow class="justify-content-center mt-3 mb-3" v-for="crossfitTrainingConfigOpt in crossfitTrainingConfigs" :key="'trainingConfig' + crossfitTrainingConfigOpt.num">
                    <CButton
                        @click.prevent="setupTrainingConfig(crossfitTrainingConfigOpt)"
                        color="primary"
                        shape="pill"
                    >
                        {{ crossfitTrainingConfigOpt.name }}
                    </CButton>
                </CRow>
            </div>
            <div v-else-if="!cameraSetFlag && cameraInfos.length > 1" class="mb-5">
                <CRow class="justify-content-center mt-5 mb-3">
                    <h4>Please, select camera:</h4>
                </CRow>
                <CRow class="justify-content-center mt-3 mb-3" v-for="(cameraInfo, index) in cameraInfos" :key="cameraInfo.deviceId">
                    <CButton
                        @click.prevent="setupCameraByInfo(cameraInfo)"
                        color="primary"
                        shape="pill"
                    >
                        {{ cameraInfo.label || `Camera ${index}` }}
                    </CButton>
                </CRow>
            </div>
            <CRow v-else-if="!readyForVideoStream" class="justify-content-center mt-10 mb-10">
                <Spinner style="width: 60px"/>
            </CRow>

            <CRow v-if="trainingMode === 'rowing' && store.myUser.onlineTrainingEnableFullscreenRowing" class="justify-content-center mt-5 mb-3" :style="{display: readyForVideoStream && isLandscapeOrientation ? 'flex' : 'none'}">
                <CButton v-if="isLandscapeOrientation && !rowingIsFullscreenFlag" @click.prevent="rowingIsFullscreenFlag = !rowingIsFullscreenFlag"
                    color="primary"
                    shape="pill"
                >
                    Go back to training
                </CButton>
                <fullscreen v-model="rowingIsFullscreenFlag" :style="{ display : rowingIsFullscreenFlag ? 'block' : 'none'}" :class="{'flelectron': store.myUser.onlineTrainingElectronAppMode}">
                    <div class="body-bg main-row">
                        <template v-if="!store.myUser.onlineTrainingElectronAppMode">
                            <video class="online-training-video body-bg__video" playsinline/>
                            <canvas class="online-training-output"
                                    :style="{
                                                            position: 'absolute',
                                                            top: 0,
                                                            left: 0,
                                                            'z-index': 10,
                                                            // 'background-color': 'rgba(255,0,0,0.1)',
                                                            width: '100%',
                                                            height: '100%',
                                                            transform: isUserFacingCamera ? 'scale(-1,1)' : 'none'
                                                        }"
                            />
                        </template>
                        <template v-if="store.myUser.onlineTrainingDoScreenPhotosExhibitionMode">
                            <video id="exhibition_photo_screen_video" style="visibility: hidden; position: absolute" playsinline/>
                            <canvas id="exhibition_photo_canvas" style="visibility: hidden; position: absolute" :width="sceenPhotoUploadingWidth" :height="sceenPhotoUploadingHeight"/>
                        </template>
                        <div class="preload">
                            <div class="preload__text">
                                <div v-for="(item, key) of onVideoMessages" :key="key+'RowingFullscreen'">
                                    <span :class="{green_preload__text: item[1]}">
                                        {{ item[0] }}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="preload2" :style="{opacity: showSpinnerOnVideo ? 1 : 0, 'will-change': 'opacity'}">
                            <div class="preload__bounce1"></div>
                            <div class="preload__bounce2"></div>
                        </div>
                    </div>
                    <div class=" wrapper">
                        <!--suppress HtmlUnknownAttribute -->
                        <header class="header" v-if="!store.myUser.onlineTrainingElectronAppMode"
                                v-touch:swipe.left="nextTrainingVideo"
                                v-touch:swipe.right="prevTrainingVideo">
                            <div :class="{header__content: true, container: true, right: rowerSideEncounterMirror === 'l'}">
                                <button :class="{noblur: true, 'header__menu-icon': true, 'menu-icon': true, 'btn-reset': true, active2: rowingFullscreenGuiBurgerActive}"  @click.prevent="rowingFullscreenGuiBurgerActive=!rowingFullscreenGuiBurgerActive">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </button>
                                <div class="header__timer timer">
                                    {{ durationStr }}
                                </div>
                                <nav class="menu" ref='burgerMenu'  :class="{active2: rowingFullscreenGuiBurgerActive}" :style="{height: rowingFullscreenGuiBurgerActive ? ((rowingTrainingMode === 'basic' ? 205 : 170) + 'px') : '0px'}">
                                    <ul class="menu__list list-reset">
                                        <li v-if="rowingTrainingMode === 'basic'" class="menu__item"><a @click.prevent="showHideTrainingVideo" href="#" class="menu__link">{{ rowingTrainingVideoInBasicModeVisible ? 'Hide training video' : 'Show training video'}}</a></li>
                                        <li class="menu__item"><a @click.prevent="muteTrainingVideo=!muteTrainingVideo" href="#" class="menu__link">{{ !muteTrainingVideo ? 'Mute training video' : 'Unmute training video'}}</a></li>
                                        <li class="menu__item"><a @click.prevent="sendRowingResetCountersCommand" href="#" class="menu__link">Reset</a></li>
                                        <li class="menu__item"><a @click.prevent="rowingIsFullscreenFlag = !rowingIsFullscreenFlag" href="#" class="menu__link">Leave fullscreen</a></li>
                                        <li class="menu__item"><a @click.prevent="startStopTraining" href="#" class="menu__link">Exit</a></li>
                                    </ul>
                                </nav>
                            </div>
                        </header>
                        <!--suppress HtmlUnknownAttribute -->
                        <main class="page"
                              v-touch:tap="swapVideoOnClick"
                              v-touch:swipe.left="nextTrainingVideo"
                              v-touch:swipe.right="prevTrainingVideo"
                              style="user-select: none"
                        >
                            <div :class="{slider: true, left: rowerSideEncounterMirror === 'l' && !store.myUser.onlineTrainingElectronAppMode }" v-if="rowingTrainingMode === 'synch' || store.myUser.onlineTrainingElectronAppMode || (rowingTrainingMode === 'basic' && rowingTrainingVideoInBasicModeVisible)">
                                <div class="slider__wrap">
                                    <div v-if="!store.myUser.onlineTrainingElectronAppMode" class="slider__slide">
                                        <template v-if="rowingTrainingMode === 'synch'">
                                            <video preload="auto" class="synch-video"
                                                   :style=" {transform: rowerSideEncounterMirror !== synchVideosInfo[synchVideo]['side'] ? 'scale(-1,1)' : 'none'}"
                                                   :muted="muteTrainingVideo"
                                                   loop/>
                                            <div :style="{
                                                                position: 'absolute',
                                                                top: 0,
                                                                left: 0,
                                                                'z-index': 9,
                                                                // 'background-color': 'rgba(255,0,0,0.1)',
                                                                width: '100%',
                                                                height: '100%',
                                                                transform: isUserFacingCamera ? 'scale(-1,1)' : 'none'
                                                            }">
                                                <div style="padding: 20px; float: right">{{ synchVideoDownloadProgress }}{{ synchVideoDownloadProgress !== null ? '%' : '' }}</div>
                                            </div>
                                            <canvas class="online-training-output-stub"
                                                    :style="{
                                                                position: 'absolute',
                                                                top: 0,
                                                                left: 0,
                                                                'z-index': 10,
                                                                // 'background-color': 'rgba(255,0,0,0.1)',
                                                                width: '100%',
                                                                height: '100%',
                                                                transform: isUserFacingCamera ? 'scale(-1,1)' : 'none'
                                                            }"
                                            />
                                        </template>
                                        <template v-else>
                                            <video preload="auto" class="synch-video"
                                                   :style=" {transform: rowerSideEncounterMirror !== trainingVideosInfo[trainingVideo]['side'] ? 'scale(-1,1)' : 'none'}"
                                                   :muted="muteTrainingVideo"
                                                   loop/>
                                            <div :style="{
                                                                position: 'absolute',
                                                                top: 0,
                                                                left: 0,
                                                                'z-index': 9,
                                                                // 'background-color': 'rgba(255,0,0,0.1)',
                                                                width: '100%',
                                                                height: '100%',
                                                                transform: isUserFacingCamera ? 'scale(-1,1)' : 'none'
                                                            }">
                                                <div style="padding: 20px; float: right">{{ synchVideoDownloadProgress }}{{ synchVideoDownloadProgress !== null ? '%' : '' }}</div>
                                            </div>
                                            <canvas class="online-training-output-stub"
                                                    :style="{
                                                                position: 'absolute',
                                                                top: 0,
                                                                left: 0,
                                                                'z-index': 10,
                                                                // 'background-color': 'rgba(255,0,0,0.1)',
                                                                width: '100%',
                                                                height: '100%',
                                                                transform: isUserFacingCamera ? 'scale(-1,1)' : 'none'
                                                            }"
                                            />
                                        </template>
                                    </div>
                                    <div v-else class="swiper-slide slider__slide">
                                        <video preload="auto" class="online-training-video"/>
                                        <canvas class="online-training-output"
                                                :style="{
                                                            position: 'absolute',
                                                            top: 0,
                                                            left: 0,
                                                            'z-index': 10,
                                                            // 'background-color': 'rgba(255,0,0,0.1)',
                                                            width: '100%',
                                                            height: '100%',
                                                            transform: isUserFacingCamera ? 'scale(-1,1)' : 'none'
                                                        }"
                                        />
                                    </div>
                                </div>
                                <div class="swiper-pagination slider__pagination"></div>
                            </div>
                            <div class="row2">
                                <div :class="{'row-block': !store.myUser.onlineTrainingHideDashboardBackground, 'row-block-transparent': store.myUser.onlineTrainingHideDashboardBackground}" v-if="coachSwitchFlag">
                                    <div class="row-text" >
                                        <template v-if="(strokeCountLastRowingPeriod === 1 || strokeCountLastRowingPeriod === 2) && ((rowingTrainingMode === 'basic' && !mainSegmentTip) || (rowingTrainingMode === 'synch' && !synchRhythmTip))">Keep going!</template>
                                        <template v-else-if="rowingTrainingMode === 'basic'">{{ mainSegmentTip ? (store.myUser.onlineTrainingHideDashboardBackground && mainSegmentTip === '—' ? '' : mainSegmentTip) : (store.myUser.onlineTrainingHideDashboardBackground ? '' : '-')}}</template>
                                        <template v-else-if="rowingTrainingMode === 'synch'">{{ synchRhythmTip ? (store.myUser.onlineTrainingHideDashboardBackground && synchRhythmTip === '—' ? '' : synchRhythmTip) : (store.myUser.onlineTrainingHideDashboardBackground ? '' : '-')}}</template>
                                    </div>
                                </div>
                                <div :class="{'row-block': !store.myUser.onlineTrainingHideDashboardBackground, 'row-block-transparent': store.myUser.onlineTrainingHideDashboardBackground, 'row-block-right': true}">
                                    <div class="swiper row-slider" v-swiper:rowingModeSwiper="{
                                                speed: 400,
                                                navigation: {
                                                    nextEl: '.row-slider__prev',
                                                    prevEl: '.row-slider__next',
                                                }}" @slideChangeTransitionEnd="rowingFullscreenGuiModeChanged">
                                        <div class="swiper-wrapper row-slider__wrap">
                                            <div class="swiper-slide row-slider__slide" data-mode="basic">
                                                TECHNIQUE
                                            </div>
                                            <div class="swiper-slide row-slider__slide" data-mode="synch">
                                                RHYTHM SYNC
                                            </div>
                                        </div>
                                        <button class="row-slider__prev btn-reset row-slider__nav noblur"></button>
                                        <button class="row-slider__next btn-reset row-slider__nav noblur"></button>
                                    </div>
                                    <div class="row-text">
                                        TOP {{ rowingTrainingMode === 'synch' ? (this.synchRhythmTop ? this.synchRhythmTop : '---') : (this.basicTechniqueTop ? this.basicTechniqueTop : '---')}}
                                    </div>
                                </div>
                            </div>
                        </main>
                        <footer class="footer" id="footer" :style="{background: store.myUser.onlineTrainingHideDashboardBackground ? 'none' : 'rgba(26, 26, 26, 0.35)'}">
                            <div class="footer__content container">
                                <div class="left-video-and-text">
                                    <div class="footer__video footer-video video" :style="{display: coachSwitchFlag ? 'block' : 'none'}">
                                        <video class="footer-video__video coach-video">
                                        </video>
                                        <button class="footer-video__muted btn-reset" @click="coachSwitchFlag = !coachSwitchFlag"><!--suppress HtmlUnknownTag -->
                                            <CIcon hight="20" name="cilVolumeHigh" style="color: black"/></button>
                                    </div>
                                    <div v-if="!coachSwitchFlag" class="footer-left-text active2">
                                        <div class="footer-left-text__content">
                                            <template v-if="strokeCountLastRowingPeriod === 1 || (rowingTrainingMode === 'basic' && !mainSegmentTip) || (rowingTrainingMode === 'synch' && !synchRhythmTip)">Keep going!</template>
                                            <template v-else-if="rowingTrainingMode === 'basic'">{{ mainSegmentTip ? mainSegmentTip : '-'}}</template>
                                            <template v-else-if="rowingTrainingMode === 'synch'">{{ synchRhythmTip ? synchRhythmTip : '-'}}</template>
                                            <button class="footer-left-text__btn btn-reset" @click="coachSwitchFlag = !coachSwitchFlag"><!--suppress HtmlUnknownTag -->
                                                <CIcon hight="20" name="cilVolumeOff" style="color: white"/></button>
                                        </div>
                                    </div>
                                </div>
                                <div class="comparison">
                                    <div class="comparison__text">YOUR SPM</div>
                                    <div class="comparison__num">{{ spm ? spm : '--' }}/{{ this.rowingTrainingMode === 'synch' ? (synchSpm ? synchSpm : '--') : (maxSpm ? maxSpm : '--') }}</div>
                                    <div class="comparison__text comparison__text--left">{{ this.rowingTrainingMode === 'synch' ? 'COACH' : 'PEAK SPM'}}</div>
                                </div>
                                <div class="footer__progress">
                                    <div v-if="rowingTrainingMode !== 'synch'" class="progresses">
                                        <div class="footer__progressbar progressbar">
                                            <span class="progressbar__line" :style="{left: LegsSegmentStart*100+'%', right: 100-LegsSegmentEnd*100+'%', opacity: LegsSegmentStart || LegsSegmentEnd ? 1 : 0, 'will-change': 'opacity, left, right' } ">LEGS</span>
                                            <span class="progressbar__green-line" :style="{left: (LegsSegmentStart+LegsSegmentStartFixDuration)*100+'%', right: 100-(LegsSegmentEnd-LegsSegmentEndFixDuration)*100+'%', opacity: LegsSegmentStartFixDuration || LegsSegmentEndFixDuration ? 1 : 0, 'will-change': 'opacity, left, right' }"></span>
                                        </div>
                                        <div class="footer__progressbar progressbar">
                                            <span class="progressbar__line" :style="{left: BackSegmentStart*100+'%', right: 100-BackSegmentEnd*100+'%', opacity: BackSegmentStart || BackSegmentEnd ? 1 : 0, 'will-change': 'opacity, left, right' }">BACK</span>
                                            <span class="progressbar__green-line" :style="{left: (BackSegmentStart+BackSegmentStartFixDuration)*100+'%', right: 100-(BackSegmentEnd-BackSegmentEndFixDuration)*100+'%', opacity: BackSegmentStartFixDuration || BackSegmentEndFixDuration ? 1 : 0, 'will-change': 'opacity, left, right' }"></span>
                                        </div>
                                        <div class="footer__progressbar progressbar">
                                            <span class="progressbar__line" :style="{left: ArmsSegmentStart*100+'%', right: 100-ArmsSegmentEnd*100+'%', opacity: ArmsSegmentStart || ArmsSegmentEnd ? 1 : 0, 'will-change': 'opacity, left, right'  }">ARMS</span>
                                            <span class="progressbar__green-line" :style="{left: (ArmsSegmentStart+ArmsSegmentStartFixDuration)*100+'%', right: 100-(ArmsSegmentEnd-ArmsSegmentEndFixDuration)*100+'%', opacity: ArmsSegmentStartFixDuration || ArmsSegmentEndFixDuration ? 1 : 0, 'will-change': 'opacity, left, right' }"></span>
                                        </div>
                                    </div>
                                    <div v-else class="double-progressbar">
                                        <span class="double-progressbar__green-line" :style="{'width': synchActorDrivePeriodEnd*100 + '%', 'will-change': 'width, opacity', 'opacity': synchActorDrivePeriodEnd ? 1 : 0}"></span>
                                        <div class="double-progressbar__white" :style="{'flex': '0 0 ' + synchDrivePeriodEnd*100 + '%', 'will-change': 'flex'}">
                                            <template v-if="synchDrivePeriodEnd"> DRIVE</template>
                                            <!--                                                Wrong css invisible-->
<!--                                            <span class="double-progressbar__white-text">{{ driveDuration ? driveDuration : '&#45;&#45;'}} SEC</span>-->
                                        </div>
                                        <div class="double-progressbar__dark">
                                            <span :style="{opacity: synchDrivePeriodEnd? 1 : 0, 'will-change': 'opacity'}"> RECOVERY</span>
<!--                                            <span class="double-progressbar__dark-text">{{ recoveryDuration ? recoveryDuration : '&#45;&#45;'}} SEC</span>-->
                                        </div>
                                    </div>
                                </div>
                                <ul class="right-data list-reset">
                                    <li class="right-data-item" :style="{display: rowingTrainingMode !== 'synch' ? 'grid' : 'none'}">
                                        <div v-swiper:rowingStyleSwiper="{
                                                speed: 400,
                                                loop: true,
                                                navigation: {
                                                    nextEl: '.right-data-item-slider__next',
                                                    prevEl: '.right-data-item-slider__prev',
                                                }}"
                                             class="right-data-item__slider swiper right-data-item-slider">
                                            <div class="swiper-wrapper">
                                                <div class="swiper-slide right-data-item-slider__slide">
                                                    Classic
                                                </div>
                                                <div class="swiper-slide right-data-item-slider__slide">
                                                    Classic
                                                </div>
                                            </div>
                                            <button class="right-data-item-slider__prev btn-reset right-data-item-slider__nav noblur"></button>
                                            <button class="right-data-item-slider__next btn-reset right-data-item-slider__nav noblur"></button>
                                        </div>


                                        <div class="right-data-item__num">{{ rowingTrainingMode === 'synch' ?  (synchRhythmStrokePercent ? synchRhythmStrokePercent : '--') : (basicTechniqueStrokePercent ? basicTechniqueStrokePercent : '--') }}</div>
                                        <div class="right-data-item__text">%</div>
                                    </li>
                                    <li v-if="rowingTrainingMode === 'synch'" class="right-data-item">
                                        <div class="right-data-item__text">MATCH</div>
                                        <div class="right-data-item__num">{{ synchRhythmStrokePercent ? synchRhythmStrokePercent : '--' }}</div>
                                        <div class="right-data-item__text">%</div>
                                    </li>
                                    <li class="right-data-item">
                                        <div class="right-data-item__text">{{ rowingTrainingMode === 'synch' ? 'MATCHED' : 'GOOD'}}</div>
                                        <div class="right-data-item__num">{{ rowingTrainingMode === 'synch' ? synchRhythmMatchedStrokeCount : basicTechniqueGoodStrokeCount }}</div>
                                        <div class="right-data-item__text">STROKES</div>
                                    </li>
                                    <li class="right-data-item">
                                        <div class="right-data-item__text">TOTAL</div>
                                        <div class="right-data-item__num">{{ rowingTrainingMode === 'synch' ? checkedStrokeCountSynchMode : checkedStrokeCountBasicMode }}</div>
                                        <div class="right-data-item__text">STROKES</div>
                                    </li>
                                </ul>
                            </div>
                            <div class="footer__down">
                                <div class="down-block">
                                    ROWERON
                                </div>
                                <div class="down-block" v-if="rowingTrainingMode !== 'synch'">
                                    DRIVE
                                </div>
                            </div>
                        </footer>
                    </div>
                </fullscreen>
            </CRow>
            <CRow v-else class="mb-4 justify-content-center main-row"
                  :style="{display: readyForVideoStream && isLandscapeOrientation ? 'flex' : 'none', 'margin-top': '55px'}">
                <div :style="'width: 1750px; transform: scale(0.75, 0.75);' + (!fullScreenFlag ? 'margin-top: -90px' : 'margin-top: -120px')">
                    <CContainer fluid>
                        <CRow class="mb-2" style="height: auto">
                            <CCol :col="!fullScreenFlag ? 3 : 0" >
                                <template v-if="trainingMode === 'rowing' && rowingTrainingMode !== 'synch' && store.myUser.onlineTrainingInvestorViewFlag">
                                    <CRow class="justify-content-center" >
                                        <p style="font-size: 35px; margin-left: 20px"><span style="color: red">•</span> Live</p>
                                    </CRow>
                                    <CRow class="mt-3">
                                        <table :style="rowingTrainingMode === 'pro' ? 'width:98%' :'width: 80%; margin-left:19%'">
                                            <tr v-for="row in tableData">
                                                <td v-for="cell in row">
                                                    <span style="font-size: 20px; font-weight: bold;">{{ cell }}</span>
                                                </td>
                                            </tr>
                                        </table>
                                    </CRow>
                                </template>
                            </CCol>
                            <CCol :col="!fullScreenFlag ? 6 : 12">
                                <CRow style="margin-bottom: -6px">
                                    <div style="width: 98%">
                                        <template v-if="trainingMode === 'rowing'">
                                            <CSelect style="float: right; margin-top: -35px; padding-bottom: 5px;   width: 173px; display: block;"
                                                     :options="store.myUser.onlineTrainingInvestorViewFlag ?
                                                     [{value: 'basic', label: 'Technique Basics'},
                                                      {value: 'pro', label: 'Pro sequence'},
                                                      {value: 'synch', label: 'Team Synchronicity'}] :
                                                      [{value: 'basic', label: 'Technique Basics'},
                                                       {value: 'pro', label: 'Pro sequence'}]"
                                                     :value.sync="rowingTrainingMode"
                                                     :disabled="!this.videoStreamProcessingStarted"
                                            >
                                            </CSelect>
                                            <CSelect v-if="rowingTrainingMode !== 'synch'" style="float: right; margin-top: -35px; padding-bottom: 5px;   width: 173px; margin-right: 20px; display: block;"
                                                     :options="
                                                     [{value: 'classic_style', label: 'Classic style'}]"
                                                     :value.sync="rowingTrainingMode"
                                                     :disabled="true"
                                            >
                                            </CSelect>
                                            <template v-if="rowingTrainingMode === 'synch'" >
                                                <CSelect style="float: right; margin-top: -35px; padding-bottom: 5px; width: 173px; display: block; margin-right: 20px"
                                                         :options="synchVideosSelectorOptions"
                                                         :value.sync="synchVideo"
                                                >
                                                </CSelect>
                                                <CSelect  v-if="this.synchVideosInfo[this.synchVideo]['multiX']" style="float: right; margin-top: -35px; padding-bottom: 5px;   width: 173px; display: block; margin-right: 20px"
                                                            :options="[
                                                                {value: 1, label: synchVideosInfo['yanko_and_vanessa']['seat1_label'] + ' (seat 1)'},
                                                                {value: 2, label: synchVideosInfo['yanko_and_vanessa']['seat2_label'] + ' (seat 2)'},
                                                            ]"
                                                            :value.sync="synchVideoSeat">
                                                </CSelect>
                                                <CSelect style="float: right; margin-top: -35px; padding-bottom: 5px;   width: 173px; display: block; margin-right: 20px"
                                                         :options="this.synchVideosInfo[this.synchVideo]['isLateral'] ? [
                                                            {value: 1, label: 'Synch SPM'},
                                                            {value: 2, label: 'Synch Rhythm'},
                                                            {value: 3, label: 'Synch Technique'},
                                                            ] : [
                                                            {value: 1, label: 'Synch SPM'},
                                                            {value: 2, label: 'Synch Rhythm'},
                                                            ]"
                                                         :value.sync="synchLevel"
                                                >
                                                </CSelect>
                                            </template>
                                            <template v-if="rowingTrainingMode !== 'synch' && store.myUser.onlineTrainingInvestorViewFlag">
                                                <CSwitch
                                                    :checked.sync="coachSwitchFlag"
                                                    color="success"
                                                    shape="pill"
                                                    style="float: left; margin-top: -30px; margin-left: 15px; display: block"
                                                    class="mb-3"
                                                    :disabled="!videoStreamProcessingStarted || !coachVideoReady"
                                                />
                                                <span style="float: left; margin-top: -27px; display: block; margin-left: 10px" class="text-muted">AI Coach</span>
                                            </template>
                                        </template>
                                        <template v-if="store.showStaffControls">
                                            <CSwitch
                                                :checked.sync="isUserFacingCamera"
                                                color="success"
                                                shape="pill"
                                                style="float: right;margin-top: -30px; margin-right: 70px; display: block"
                                                class="mb-3"
                                            />
                                            <span style="float: right;margin-top: -29px; display: block; margin-right: 7px" class="text-muted">Mirror</span>
                                            <CSwitch
                                                :checked.sync="debugShowPosesAllTimeFlag"
                                                color="success"
                                                shape="pill"
                                                style="float: right; margin-top: -30px; margin-right: 55px; display: block"
                                                class="mb-3"
                                            />
                                            <span style="float: right;margin-top: -29px; display: block; margin-right: 7px" class="text-muted">Show poses</span>
                                        </template>
                                        <template v-if="!store.myUser.onlineTrainingInvestorViewFlag" >
                                            <CSwitch
                                                :checked.sync="isUserFacingCamera"
                                                color="success"
                                                shape="pill"
                                                style="float: left; margin-top: -30px; margin-left: 15px; display: block"
                                                class="mb-3"
                                                :disabled="!videoStreamProcessingStarted"
                                            />
                                            <span style="float: left; margin-top: -27px; display: block; margin-left: 10px" class="text-muted">Mirror</span>
                                        </template>

                                    </div>
                                </CRow>
                                <div :style="{
                                            position: 'relative',
                                            width: '100%',
                                            height: 'auto'}"
                                     @click="swapShowInCornerIfPossible"
                                >
                                    <div :style="{
                                            position: cameraStreamShowInCornerMode ? 'absolute' : 'relative',
                                            width: cameraStreamShowInCornerMode ? '33%' : '100%',
                                            height: 'auto',
                                            'z-index': 5,
                                            right: rowerSideEncounterMirror === 'l' ? 'auto' : '0px',
                                            left: rowerSideEncounterMirror === 'l' ? '0px' : 'auto',
                                            }"
                                    >
                                        <video class="online-training-video" :style="{
                                            width: '100%',
                                            height: '100%',
                                            display: 'flex',
                                            'border-radius': '10px',
                                            transform: isUserFacingCamera ? 'scale(-1,1)' : 'none',
                                            'z-index': 5,
                                            'background-color': 'rgb(170,160,160, 0.3)'
                                        }"
                                               playsinline/>
                                        <canvas class="online-training-output"
                                                :style="{
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: 0,
                                                        'z-index': 10,
                                                        // 'background-color': 'rgba(255,0,0,0.1)',
                                                        width: '100%',
                                                        height: '100%',
                                                        transform: isUserFacingCamera ? 'scale(-1,1)' : 'none'
                                                    }"
                                        />
                                    </div>
                                    <video class="coach-video" :style="{
                                                        position: 'absolute',
                                                        top: '0px',
                                                        right: '0px',
                                                        'z-index': 20,
                                                        width: '33%',
                                                        visibility: coachSwitchFlag ? 'visible' : 'hidden',
                                                        'border-radius': '10px'
                                                    }">
                                    </video>
                                    <template v-if="rowingTrainingMode === 'synch'">
                                        <video preload="auto" :style="{
                                                            position: cameraStreamShowInCornerMode ? 'relative' : 'absolute',
                                                            top: '0px',
                                                            right: rowerSideEncounterMirror === 'l' ? 'auto' : '0px',
                                                            left: rowerSideEncounterMirror === 'l' ? '0px' : 'auto',
                                                            'z-index': cameraStreamShowInCornerMode ? 3 : 8,
                                                            width: cameraStreamShowInCornerMode ? '100%' : '33%',
                                                            height: 'auto',
                                                            'min-height':  cameraStreamShowInCornerMode ? '750px' : '180px',
                                                            'border-radius': '10px',
                                                             transform: rowerSideEncounterMirror !== synchVideosInfo[synchVideo]['side'] ? 'scale(-1,1)' : 'none',
                                                        }"
                                               class="synch-video"
                                               loop/>
                                        <span v-if="synchVideoDownloadProgress !== null" :style="{
                                            display: 'block',
                                            position: 'absolute',
                                            top: '10px',
                                            right: rowerSideEncounterMirror === 'l' ? 'auto' : '20px',
                                            left: rowerSideEncounterMirror === 'l' ? '20px' : 'auto',
                                            'font-size': '30px',
                                            'z-index': 40,
                                            'color': 'white'
                                            }">{{ synchVideoDownloadProgress }}%
                                        </span>
                                    </template>
                                    <spinner style="position: absolute; right: 30px; bottom: 35px; z-index: 20; width: 50px;" class="spinner-white"
                                             v-if="showSpinnerOnVideo"/>
                                    <div v-if="fullScreenFlag" style="text-align: left; position: absolute; bottom:15px; left:15px; width: 99%; z-index: 35">
                                        <div style="background-color: rgba(20, 20, 20, 0.35); display: inline-flex; padding: 10px; border-radius: 10px">
                                            <div style="font-size: 35px; color: rgba(240, 240, 240, 0.85); display: inline;">

<!--                                                <b>Stroke #{{ strokeCount }}</b><br>-->
<!--                                                <b>Synch video stroke #{{ synchStrokeNum }}</b><br>-->
<!--                                                <b>synchRhythmActorStrokeNum #{{ synchRhythmActorStrokeNum }}</b><br>-->
<!--                                                <span style="margin-right:15px">synchCatchDiffMs {{ synchCatchDiffMs >= 0 ? '+' : ''}}{{ synchCatchDiffMs }}</span><br>-->
<!--                                                <span style="margin-right:15px">synchFinishDiffMs {{ synchFinishDiffMs >= 0 ? '+' : ''}}{{ synchFinishDiffMs }}</span><br>-->

                                                <template v-if="rowingTrainingMode === 'synch'">
                                                    <template v-if="synchLevel === 1">
                                                        <span style="margin-right:15px">SPM {{ spm !== null ? spm : '- ' }}<sup><span style="font-size: 20px">\</span>{{ synchSpm !== null ? synchSpm : '- ' }}<span style="font-size: 25px"></span></sup></span><br>
                                                        <div style="margin-top: -35px; margin-bottom: -60px; opacity: 0.5">____________</div><br>
                                                        <span>Score {{ synchSpmMetrics }}</span>
                                                    </template>

                                                    <template v-if="synchLevel === 2">
                                                        <span style="margin-right:15px">Drive {{ driveDuration !== null ? driveDuration : '- ' }}<sup><span style="font-size: 20px">\</span>{{ synchDriveDuration !== null ? synchDriveDuration : '- ' }}<span style="font-size: 25px">s</span></sup></span><br>
                                                        <span style="margin-right:15px">Recovery {{ recoveryDuration !== null ? recoveryDuration : '- ' }}<sup><span style="font-size: 20px">\</span>{{ synchRecoveryDuration !== null ? synchRecoveryDuration : '- ' }}<span style="font-size: 25px">s</span></sup></span><br>
                                                        <div style="margin-top: -35px; margin-bottom: -60px; opacity: 0.5">____________</div><br>
                                                        <span>Score {{ synchRhythmMetrics }}</span>
                                                    </template>

                                                    <template v-if="synchLevel === 3">
                                                        <span style="margin-right:15px">L↔B {{ lbSeparation !== null ? lbSeparation : '- ' }}<sup><span style="font-size: 20px">\</span>{{ synchLbSeparation !== null ? synchLbSeparation : '- ' }}<span style="font-size: 25px">%</span></sup></span><br>
                                                        <span style="margin-right:15px">B↔A {{ baSeparation !== null ? baSeparation : '- ' }}<sup><span style="font-size: 20px">\</span>{{ synchBaSeparation !== null ? synchBaSeparation : '- ' }}<span style="font-size: 25px">%</span></sup></span><br>
                                                        <span style="margin-right:15px">Shins {{ shinsAngle !== null ? shinsAngle : '- ' }}<sup><span style="font-size: 20px">\</span>{{ synchShinsAngle !== null ? synchShinsAngle : '- ' }}°</sup></span><br>
                                                        <span style="margin-right:15px">Catch {{ forwardAngle !== null ? forwardAngle : '- ' }}<sup><span style="font-size: 20px">\</span>{{ synchForwardAngle !== null ? synchForwardAngle : '- ' }}°</sup></span><br>
                                                        <span style="margin-right:15px">Finish {{ laybackAngle !== null ? laybackAngle : '- ' }}<sup><span style="font-size: 20px">\</span>{{ synchLaybackAngle !== null ? synchLaybackAngle : '- ' }}°</sup></span><br>
                                                        <div style="margin-top: -35px; margin-bottom: -60px; opacity: 0.3">____________</div><br>
                                                        <span>Score {{ synchTechniqueMetrics }}</span>
                                                    </template>
                                                </template>

                                                <template v-if="trainingMode === 'crossfit'">
                                                    <span v-if="crossfitSquatsCountTarget"  style="margin-right:15px">{{ crossfitPushupsCountTarget || crossfitBurpeesCountTarget ?  '1.' : '' }} Squats {{ crossfitSquatsCount }} from {{ crossfitSquatsCountTarget }} <template v-if="crossfitSquatsCount >= crossfitSquatsCountTarget"><span style="margin-left: 10px; color: #09b609">✓</span></template><br></span>
                                                    <span v-if="crossfitPushupsCountTarget" style="margin-right:15px">{{ crossfitSquatsCountTarget || crossfitBurpeesCountTarget ?  '2.' : '' }} Push-ups {{ crossfitPushupsCount }} from {{ crossfitPushupsCountTarget }} <template v-if="crossfitPushupsCount >= crossfitPushupsCountTarget"><span style="margin-left: 10px; color: #09b609">✓</span></template><br></span>
                                                    <span v-if="crossfitBurpeesCountTarget" style="margin-right:15px">{{ crossfitPushupsCountTarget && crossfitSquatsCountTarget ?  '3.' : '' }} Burpees {{ crossfitBurpeesCount }} from {{ crossfitBurpeesCountTarget }} <template v-if="crossfitBurpeesCount >= crossfitBurpeesCountTarget"><span style="margin-left: 10px; color: #09b609">✓</span></template><br></span>
                                                    <span style="line-height: 100px; margin-left: 60px; font-size: 55px;" v-if="crossfitSquatsCount >= crossfitSquatsCountTarget && crossfitPushupsCount >= crossfitPushupsCountTarget && crossfitBurpeesCount >= crossfitBurpeesCountTarget">Well done!</span>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="Object.keys(onVideoMessages).length " id="online-training-info-container"
                                         :style="'text-align: left; position: absolute; z-index: 40; ' + (rowingTrainingMode === 'synch' ? 'top:10px; left:10px;' : 'top:7px; left:7px;') + (coachSwitchFlag || rowingTrainingMode === 'synch' ? 'width: 65.2%;' : 'width: 98.2%;')">
                                        <!--suppress JSUnusedLocalSymbols -->
                                        <div v-for="(item, key, index) of onVideoMessages" :key="key">
                                            <h1 :style="{
                                                         display: 'inline-flex',
                                                         padding: rowingTrainingMode === 'synch' ? '7px' : '5px',
                                                         'font-size': rowingTrainingMode === 'synch' ? '20px' : '15px',
                                                         'background-color': onVideoMessages[key][1] ? 'rgb(0,200,23, 0.5)' : 'rgba(200, 173,0, 0.5)',
                                                         color:'#ffffff',
                                                         'border-radius': '10px',
                                                         }">
                                                {{ onVideoMessages[key][0] }}
                                            </h1>
                                            <br>
                                        </div>
                                    </div>
                                </div>
                            </CCol>
                            <CCol col="3" v-if="trainingMode === 'rowing' && rowingTrainingMode !== 'synch'">
                                <template v-if="rowingTrainingMode === 'pro'">
<!--                                    <CRow class="justify-content-center">-->
<!--                                        <CCol col="6">-->
<!--                                            <PieChartWithLabel :chartData="scorePieChartDriveLbSeparationAvgData" :options="scorePieChartDriveLbSeparationAvgOptions"/>-->
<!--                                        </CCol>-->
<!--                                    </CRow>-->
<!--                                    <CRow style="margin-top: -80px">-->
<!--                                        <CCol col="5">-->
<!--                                            <PieChartWithLabel :chartData="scorePieChartDriveLbSeparationData" :options="scorePieChartDriveLbSeparationOptions"/>-->
<!--                                        </CCol>-->
<!--                                        <CCol col="2"/>-->
<!--                                        <CCol col="5">-->
<!--                                            <PieChartWithLabel :chartData="scorePieChartDriveBaSeparationData" :options="scorePieChartDriveBaSeparationOptions"/>-->
<!--                                        </CCol>-->
<!--                                    </CRow>-->
                                    <CRow style="margin-top: 20px; margin-bottom: 40px">
                                        <CCol col="6">
                                            <PieChartWithLabel :chartData="scorePieChartDriveLbSeparationData" :options="scorePieChartDriveLbSeparationOptions"/>
                                        </CCol>
                                        <CCol col="6">
                                            <PieChartWithLabel :chartData="scorePieChartDriveBaSeparationData" :options="scorePieChartDriveBaSeparationOptions"/>
                                        </CCol>
                                    </CRow>
                                    <LineChart :chartData="handleTrajectoryLineChartData" :options="handleTrajectoryLineChartOptions"/>
                                </template>
                                <template v-else>
                                    <div>
                                        <BodyAngleBar :mainLabel="'Shins'" :startLabel="rowerSideEncounterMirror === 'r' ? 'Under compressed' : 'Over compressed'" :tragetLabel="'12 pm'" :endLabel="rowerSideEncounterMirror === 'r' ? 'Over compressed' : 'Under compressed'" :segmentStart="0.38" :segmentEnd="0.62" :cursorPos="shinsAnglePos" :segment-color="LegsSegmentColor" :hatchingColor="hatchingColor"/>
                                        <BodyAngleBar :mainLabel="'Catch'" :startLabel="rowerSideEncounterMirror === 'r' ? '12 pm' : '10 am'" :tragetLabel="rowerSideEncounterMirror === 'r' ? '1 pm' : '11 am'"  :endLabel="rowerSideEncounterMirror === 'r' ? '2 pm' : '12 pm'" :segmentStart="0.33" :segmentEnd="0.67" :cursorPos="forwardAnglePos" :segment-color="BackSegmentColor" :hatchingColor="hatchingColor"/>
                                        <BodyAngleBar :mainLabel="'Finish'" :startLabel="rowerSideEncounterMirror === 'r' ? '10 am' : '12 pm'" :tragetLabel="rowerSideEncounterMirror === 'r' ? '11 am' : '1 pm'"  :endLabel="rowerSideEncounterMirror === 'r' ? '12 pm' : '2 pm'" :segmentStart="0.33" :segmentEnd="0.67" :cursorPos="laybackAnglePos" :segment-color="BackSegmentColor" :hatchingColor="hatchingColor"/>
                                     </div>
                                </template>
                            </CCol>
                        </CRow>
                        <CRow v-if="trainingMode === 'rowing' && rowingTrainingMode !== 'synch'">
                            <CCol col="3" style="margin-top: 45px">
                                <template v-if="rowingTrainingMode !== 'pro'">
                                    <!--suppress HtmlUnknownTag -->
                                    <CIcon height="61" name="cilThumbUp" style="margin-left: 185px; margin-bottom: 10px" v-if="LegsSegmentOkFlag"/>
                                    <p style="margin-left: 135px; font-size: 22px; font-weight: bold; margin-top: 11px; margin-bottom: 27px" v-else>{{ LegsSegmentTip }}</p>
                                    <!--suppress HtmlUnknownTag -->
                                    <CIcon height="61" name="cilThumbUp" style="margin-left: 185px; margin-bottom: 10px" v-if="BackSegmentOkFlag"/>
                                    <p style="margin-left: 135px; font-size: 22px; font-weight: bold; margin-top: 11px; margin-bottom: 27px" v-else>{{ BackSegmentTip }}</p>
                                    <!--suppress HtmlUnknownTag -->
                                    <CIcon height="61" name="cilThumbUp" style="margin-left: 185px; margin-bottom: 10px" v-if="ArmsSegmentOkFlag"/>
                                    <p style="margin-left: 135px; font-size: 22px; font-weight: bold; margin-top: 11px; margin-bottom: 27px" v-else>{{ ArmsSegmentTip }}</p>
                                </template>
                            </CCol>
                            <CCol col="6">
                                <LineChart :chartData="speedLineChartData" :options="speedLineChartOptions" v-if="rowingTrainingMode === 'pro'" class="pl-1" />
                                <template v-else>
                                        <CRow class="justify-content-center mb-2" style="margin-top: 12px"><h6 style="font-weight: bold">Drive Sequence</h6></CRow>
                                        <BodyPartsSpeedSegment :segmentName="'Legs'" :segmentStart="LegsSegmentStart" :segmentEnd="LegsSegmentEnd" :segmentColor="LegsSegmentColor" :segmentStartFixDuration="LegsSegmentStartFixDuration" :segmentEndFixDuration="LegsSegmentEndFixDuration" :hatchingColor="hatchingColor"/>
                                        <BodyPartsSpeedSegment :segmentName="'Back'" :segmentStart="BackSegmentStart" :segmentEnd="BackSegmentEnd" :segmentColor="BackSegmentColor" :segmentStartFixDuration="BackSegmentStartFixDuration" :segmentEndFixDuration="BackSegmentEndFixDuration" :hatchingColor="hatchingColor"/>
                                        <BodyPartsSpeedSegment :segmentName="'Arms'" :segmentStart="ArmsSegmentStart" :segmentEnd="ArmsSegmentEnd" :segmentColor="ArmsSegmentColor" :segmentStartFixDuration="ArmsSegmentStartFixDuration" :segmentEndFixDuration="ArmsSegmentEndFixDuration" :hatchingColor="hatchingColor"/>
                                </template>
                            </CCol>
                            <CCol col="3" :style="rowingTrainingMode === 'pro' ? '' : 'margin-top: 12px'">
                                <h1 class="d-flex justify-content-center mt-4 mb-4" style="font-size: 50px">{{ spm !== null ? spm.toFixed(0) + ' SPM' : '—' }}</h1>
                                <h1 v-if="strokeCountInCircle" class="d-flex justify-content-center" style="margin-top: 40px;"><span  style="font-size: 50px;" class="numberCircle"><span style="display: block; margin-bottom: 6px;">{{ strokeCountInCircle}}</span></span></h1>
                                <h1 v-if="strokeText" class="d-flex justify-content-center" style="font-size: 50px; margin-top: 40px; margin-bottom: 40px">{{ strokeText }}</h1>
                                <h1 v-if="store.showStaffControls" class="d-flex justify-content-center" style="font-size: 50px; margin-top: 10px;" >Stroke #{{ strokeCount }}</h1>
                            </CCol>
                        </CRow>
                    </CContainer>
                </div>
            </CRow>
            <canvas id="online-training-buffer" style="display: none"/>
        </div>
    </Portal>
</template>
<!--suppress PointlessArithmeticExpressionJS -->
<script>
    /* eslint-disable */


    import Chart from 'chart.js'
    import * as SimplePeer from 'simple-peer'
    import { component } from 'vue-fullscreen'
    import * as localForage from 'localforage'

    Chart.pluginService.register({
        afterDraw: function (chart) {
            if (chart.config.options.forceHeight) {
                chart.canvas.parentNode.style.height = chart.config.options.forceHeight + 'px'
            }
        }
    });

    import Portal from '@/components/layouts/Portal'
    import LineChart from '@/components/LineChart'
    import PieChartWithLabel from '@/components/PieChartWithLabel'
    import {backendURL, store, websocketsURL} from '@/scripts/globals'
    // noinspection ES6UnusedImports
    import {isTouchDevice, printSeparated, sleep} from '@/scripts/utils'
    import Spinner from '@/components/Spinner'
    import Stats from 'stats-js'
    import BodyPartsSpeedSegment from "@/components/BodyPartsSpeedSegment";
    import BodyAngleBar from "@/components/BodyAngleBar";
    import {elementScrollIntoViewPolyfill} from "seamless-scroll-polyfill";
    import moment from "moment"
    import axios from "axios";
    import {apolloClient} from "@/plugins/apollo";
    import gql from "graphql-tag";

    elementScrollIntoViewPolyfill()

    let WebsocketFailedTxt = 'Connection to the real-time analysis server failed'

    let initalSynchVideo = 'steve_1a'
    let initalTrainingVideo = 'actor_boat_1a'

    // noinspection ES6MissingAwait
    export default {
        components: {
            BodyAngleBar,
            BodyPartsSpeedSegment,
            Portal,
            Spinner,
            LineChart,
            PieChartWithLabel,
            fullscreen: component
        },
        data() {
            let scorePieChartDataLb = {
                datasets: [{
                    data: [0, 100],
                    backgroundColor: [
                        "rgba(26, 132, 57, 0.6)",
                        "rgba(0,0,0,0)",
                    ],
                    borderColor: [
                        "rgba(26, 132, 57, 1)",
                        "rgba(0,0,0,0)",
                    ]
                }],
                centerText: {
                    color: '#666', // Default is #000000
                    font: 'Arial', // Default is Arial
                    fontStyle: 'bold', // Default is ' '
                    sidePadding: 20, // Default is 20 (as a percentage)
                    minFontSize: 5,
                    maxFontSize: 31,
                    lineHeight: 25, // Default is 25 (in px), used for when text wraps
                },
                centerText2: {
                    color: 'rgba(26, 132, 57, 0.7)',
                    font: 'Arial',
                    fontStyle: '',
                    fontSize: 20,
                    lineHeight: 25,
                    shiftDownPx: 28,
                    shiftBaseTextUpPx: 4,
                    text: '>75'
                },
            }

            let scorePieChartDataBa = {
                datasets: [{
                    data: [0, 100],
                    backgroundColor: [
                        "rgba(26, 132, 57, 0.6)",
                        "rgba(0,0,0,0)",
                    ],
                    borderColor: [
                        "rgba(26, 132, 57, 1)",
                        "rgba(0,0,0,0)",
                    ]
                }],
                centerText: {
                    color: '#666', // Default is #000000
                    font: 'Arial', // Default is Arial
                    fontStyle: 'bold', // Default is ' '
                    sidePadding: 20, // Default is 20 (as a percentage)
                    minFontSize: 5,
                    maxFontSize: 31,
                    lineHeight: 25 // Default is 25 (in px), used for when text wraps
                },
                centerText2: {
                    color: 'rgba(26, 132, 57, 0.7)',
                    font: 'Arial',
                    fontStyle: '',
                    fontSize: 20,
                    lineHeight: 25,
                    shiftDownPx: 28,
                    shiftBaseTextUpPx: 4,
                    text: '>60'
                },
            }

            let scorePieChartOptions = {
                cutoutPercentage: 62,
                title: {
                    display: true
                },
                tooltips: {
                    enabled: false
                },
                animation: {
                    duration: 800
                }
            }

            let scorePieChartDriveLbSeparationData = JSON.parse(JSON.stringify(scorePieChartDataLb))
            let scorePieChartDriveLbSeparationOptions = JSON.parse(JSON.stringify(scorePieChartOptions))
            scorePieChartDriveLbSeparationOptions.title.text = ['Drive Legs&Back', 'separation']

            let scorePieChartDriveBaSeparationData = JSON.parse(JSON.stringify(scorePieChartDataBa))
            let scorePieChartDriveBaSeparationOptions = JSON.parse(JSON.stringify(scorePieChartOptions))
            scorePieChartDriveBaSeparationOptions.title.text = ['Drive Back&Arms', 'separation']

            let scorePieChartDriveLbSeparationAvgData = JSON.parse(JSON.stringify(scorePieChartDataLb))
            let scorePieChartDriveLbSeparationAvgOptions = JSON.parse(JSON.stringify(scorePieChartOptions))
            scorePieChartDriveLbSeparationAvgOptions.title.text = ['Drive Legs&Back', 'separation average']

            let canvasSenderWH_mult = 24 // should be dividable by 2
            let webrtcSenderWH_mult = 30
            let outputCanvasWH_mult = webrtcSenderWH_mult

            let synchVideosInfo =
                {
                'steve_1a': {label : 'Steve Whelpley', multiX: false, isLateral: true, side: 'r', src: require('../assets/online-training-videos/cycle_video_steve_hq.mp4')},
                // 'hammer_good_morning': {label : 'Hammer', multiX: false, isLateral: true, side: 'r', src: require('../assets/online-training-videos/cycle_video_hammer_good_morning.mp4')},
                // 'fred': {label : 'Fred', multiX: false, isLateral: true, side: 'l', src: require('../assets/online-training-videos/cycle_video_fred.mp4')},
                // 'yanko_and_vanessa': {label : 'Yanko and Vanessa', multiX: true, isLateral: true, side: 'l', seat1_label: 'Yanko', seat2_label: 'Vanessa', src: require('../assets/online-training-videos/cycle_video_yanko_and_vanessa.mp4')},
                // 'tom_frontal': {label : 'Tom (frontal view)', multiX: false, isLateral: false, side: 'r', src: require('../assets/online-training-videos/cycle_video_tom_frontal.mp4')},
                // 'juliy_frontal_erg': {label : 'Juliy (frontal view)', multiX: false, isLateral: false, side: 'r', src: require('../assets/online-training-videos/cycle_video_juliy_frontal_erg.mp4')}
                }
            let trainingVideosInfo = {
                'actor_boat_1a': {label : 'Actor 1', multiX: false, isLateral: true, side: 'r', src: require('../assets/online-training-videos/actor_1.mp4')},
                'actor_erg_1a': {label : 'Actor erg 1', multiX: false, isLateral: true, side: 'l', src: require('../assets/online-training-videos/actor_at_erg_spain.mp4')},
                // 'hammer_good_morning': {label : 'Hammer', multiX: false, isLateral: true, side: 'r', src: require('../assets/online-training-videos/cycle_video_hammer_good_morning.mp4')},
            }

            let synchVideosSelectorOptions = []
            for (let video in synchVideosInfo)
                { // noinspection JSUnfilteredForInLoop
                    synchVideosSelectorOptions.push({'value': video, 'label': synchVideosInfo[video]['label']})
                }


            return {
                store,
                crossfitCoachVideoFragments: {
                    'squats_intro': [0.5, 6.60],
                    1: [7.22, 9.01],
                    2: [9.01, 10.10],
                    3: [10.10, 11.16],
                    4: [11.16, 12.17],
                    5: [12.17, 13.26],
                    6: [13.26, 15.01],
                    7: [15.01, 16.10],
                    8: [16.10, 17.10],
                    9: [17.10, 19.07],
                    'pushups_intro': [19.07, 22.16],
                    'burpees_intro': [22.16, 26.15],
                    'well_done': [28.0, 30.2]
                },
                rowingCoachVideoFragments: {
                    intro_move: [0, 2.1],
                    finish_legs_earlier: [2.1, 3.9],
                    finish_legs_later: [4.1, 5.5],
                    start_legs_earlier: [6.2, 7.9],
                    start_legs_later: [8.3, 10.0],
                    start_back_later: [11.0, 12.3],
                    finish_back_earlier: [12.5, 14.4],
                    start_back_earlier: [14.7, 16.6],
                    finish_back_later: [16.7, 18.4],
                    start_arms_later: [20.1, 20.8],
                    start_arms_earlier: [22.4, 24.2],
                    finish_arms_earlier: [25.9, 26.7],
                    finish_arms_later: [28.25, 29.85],

                    do_shorter_drive_and_longer_recovery:[31.7, 32.8],
                    do_longer_drive_and_shorter_recovery: [34.5, 36.6],

                    all_good: [38.2, 39.0]
                },
                colWidths: [100, 80, 12, 50],
                tableData: [
                    [],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [],
                ],
                crossfitTrainingConfigs: [
                    {
                        num: 1,
                        name: 'WarmUp: 3 squats, 3 pushups, 3 burpees',
                        squats: 3,
                        pushups: 3,
                        burpees: 3
                    },
                    {
                        num: 2,
                        name: 'LimberUp: 6 squats, 6 push-ups, 6 burpees',
                        squats: 6,
                        pushups: 6,
                        burpees: 6
                    },
                    {
                        num: 3,
                        name: 'SweatUp: 9 squats, 9 push-ups, 9 burpees',
                        squats: 9,
                        pushups: 9,
                        burpees: 9
                    },
                    {
                        num: 4,
                        name: '20 squats',
                        squats: 20,
                        pushups: 0,
                        burpees: 0
                    },
                    {
                        num: 5,
                        name: '20 push-ups',
                        squats: 0,
                        pushups: 20,
                        burpees: 0
                    },
                    {
                        num: 6,
                        name: '20 burpees',
                        squats: 0,
                        pushups: 0,
                        burpees: 20
                    }
                ],
                crossfitTrainingConfig: null,
                tableDataStoryPro: [
                    [
                        ['John', 'Concept2', '21', '90/80﹪'],
                        ['Jane', 'Hydrow', '19', '80/80﹪'],
                        ['Danny', 'Ergatta', '28', '70/80﹪'],
                        ['Bob', 'Hydrow', '21', '60/95﹪'],
                        ['Yuki', 'Ergatta', '25', '55/70﹪'],
                        ['Kate', 'Aviron', '22', '50/55﹪'],
                        ['Julia', 'Aviron', '24', '30/60﹪']
                    ],
                    [
                        ['Jane', 'Hydrow', '20', '90/80﹪'],
                        ['John', 'Concept2', '23', '85/80﹪'],
                        ['Bob', 'Hydrow', '21', '70/95﹪'],
                        ['Danny', 'Ergatta', '27', '65/80﹪'],
                        ['Kate', 'Aviron', '22', '55/55﹪'],
                        ['Yuki', 'Ergatta', '24', '50/75﹪'],
                        ['Julia', 'Aviron', '23', '30/60﹪']
                    ],
                    [
                        ['John', 'Concept2', '22', '90/80﹪'],
                        ['Jane', 'Hydrow', '19', '85/80﹪'],
                        ['Bob', 'Hydrow', '20', '65/95﹪'],
                        ['Danny', 'Ergatta', '28', '65/80﹪'],
                        ['Yuki', 'Ergatta', '24', '55/70﹪'],
                        ['Kate', 'Aviron', '22', '50/55﹪'],
                        ['Julia', 'Aviron', '24', '35/55﹪']
                    ],
                    [
                        ['John', 'Concept2', '21', '90/75﹪'],
                        ['Jane', 'Hydrow', '18', '80/85﹪'],
                        ['Bob', 'Hydrow', '21', '80/95﹪'],
                        ['Danny', 'Ergatta', '28', '70/80﹪'],
                        ['Yuki', 'Ergatta', '24', '50/75﹪'],
                        ['Kate', 'Aviron', '22', '50/60﹪'],
                        ['Julia', 'Aviron', '23', '35/50﹪']
                    ]
                ],
                tableDataStory: [
                    [
                        ['John', 'Concept2', '21', '✓'],
                        ['Jane', 'Hydrow', '19', '✓'],
                        ['Danny', 'Ergatta', '28', '✓'],
                        ['Bob', 'Hydrow', '21', '✓'],
                        ['Yuki', 'Ergatta', '25', '✗'],
                        ['Kate', 'Aviron', '22', '✗'],
                        ['Julia', 'Aviron', '24', '✗']
                    ],
                    [
                        ['Jane', 'Hydrow', '20', '✓'],
                        ['John', 'Concept2', '23', '✓'],
                        ['Bob', 'Hydrow', '21', '✓'],
                        ['Danny', 'Ergatta', '27', '✗'],
                        ['Kate', 'Aviron', '22', '✗'],
                        ['Yuki', 'Ergatta', '24', '✗'],
                        ['Julia', 'Aviron', '23', '✗']
                    ],
                    [
                        ['John', 'Concept2', '22', '✓'],
                        ['Jane', 'Hydrow', '19', '✓'],
                        ['Bob', 'Hydrow', '20', '✓'],
                        ['Danny', 'Ergatta', '28', '✓'],
                        ['Yuki', 'Ergatta', '24', '✓'],
                        ['Kate', 'Aviron', '22', '✗'],
                        ['Julia', 'Aviron', '24', '✗']
                    ],
                    [
                        ['John', 'Concept2', '21', '✓'],
                        ['Jane', 'Hydrow', '18', '✓'],
                        ['Bob', 'Hydrow', '21', '✗'],
                        ['Danny', 'Ergatta', '28', '✗'],
                        ['Yuki', 'Ergatta', '24', '✗'],
                        ['Kate', 'Aviron', '22', '✗'],
                        ['Julia', 'Aviron', '23', '✗']
                    ]
                ],
                isTouchDevice: isTouchDevice(),
                requestVideoFrameCallbackAvailable: 'requestVideoFrameCallback' in HTMLVideoElement.prototype,
                coachVideoRequest: null,
                coachVideoDownloadProgress: null,
                coachVideoReady: false,
                coachVideoDom: null,
                coachVideoTimeoutHandle: null,
                rowingTrainingMode: ['basic', 'pro', 'synch'][0],
                synchVideo: initalSynchVideo,
                trainingVideo: initalTrainingVideo,
                synchLevel: 1,
                synchVideoSeat: 1,
                synchVideosInfo,
                trainingVideosInfo,
                synchVideosSelectorOptions,
                synchVideoDownloadProgress: null,
                synchVideoDom: null,
                synchVideoRequest: null,
                synchVideoIsPlaying: false,
                basicTechniqueStrokePercent: null,
                basicTechniqueGoodStrokeCount: 0,
                basicTechniqueTop: null,
                synchSpm: null,
                synchSpmMetrics: 0,
                synchCatchDiffMs: null,
                synchFinishDiffMs: null,
                synchRhythmActorStrokeNum: null,
                synchDriveDuration: null,
                synchRecoveryDuration: null,
                synchStrokeNum: null,
                synchRhythmMetrics: 0,
                synchRhythmStrokePercent: null,
                synchRhythmMatchedStrokeCount: 0,
                synchRhythmTop: null,
                synchRhythmTip: '',
                synchRhythmTipSlug: null,
                synchDrivePeriodEnd: null,
                synchActorDrivePeriodEnd: null,
                synchLaybackAngle: null,
                synchForwardAngle: null,
                synchShinsAngle: null,
                synchLbSeparation: null,
                synchBaSeparation: null,
                synchTechniqueMetrics: 0,
                cameraStreamShowInCornerMode: false,
                coachSwitchFlag: true,
                strokeCount: 0,
                strokeCountLastRowingPeriod: 0,
                checkedStrokeCountBasicMode: 0,
                checkedStrokeCountProMode: 0,
                checkedStrokeCountSynchMode: 0,
                analyzedStrokeCount: 0,
                strokeCountInCircle: null,
                strokeText: 'Ready?',
                spm: null,
                maxSpm: null,
                driveDuration: null,
                recoveryDuration: null,
                laybackAngle: null,
                forwardAngle: null,
                shinsAngle: null,
                lbSeparation: null,
                baSeparation: null,
                lbSeparationAvg: null,
                lbSeparationOkFlag: null,
                baSeparationOkFlag: null,
                lbSeparationAvgOkFlag: null,
                lastRegularFrameClientTs: null,
                clientDropout: store.myUser.onlineTrainingDoDropoutOnWebsocketVideoClient ? 2 : null,
                regularFrameNum: 0,
                isLandscapeOrientation: true,
                showSpinnerOnVideo: false,
                trainingStarted: false,
                readyForVideoStream: false,
                videoStreamProcessingStarted: false,
                processingWorkflowStartTs: null,
                frameCaptureHandle: null,
                synchTsSenderHandle: null,
                currentMediaStream: null,
                cameraInfos: [],
                errorText: null,
                onVideoMessages: {},
                settingsSetPartiallyFlag: null,
                settingsSetFlag: null,
                cameraSetFlag: null,
                isUserFacingCamera: null,
                debugShowPosesAllTimeFlag: false,
                videoWH: null,
                videoFPS: null,
                clientDropout2Interval: null,
                lastCapturedJpg: null,
                canvasSenderWH: [16*canvasSenderWH_mult, 9*canvasSenderWH_mult],
                webrtcSenderWH: [16*webrtcSenderWH_mult, 9*webrtcSenderWH_mult],
                outputCanvasWH: [16*outputCanvasWH_mult, 9*outputCanvasWH_mult],
                bufferCanvas: null,
                outputCanvas: null,
                videoDom: null,
                output2dCtx: null,
                buffer2dCtx: null,
                stats: null,
                socket: null,
                webrtcToServerConnectionSuccessful: null,
                simplePeerToServer: null,
                webrtcToDisplayConnectionSuccessful: null,
                simplePeerToDisplay: null,
                webrtcFromCameraConnectionSuccessful: null,
                simplePeerFromCamera: null,
                trainingMode: 'rowing',
                deviceMode: store.myUser.onlineTrainingAllowTwoDeviceSetup ? null : 'camera_and_display',
                socketHandhsakeStatus: null,
                drawPoseColor: 'rgba(0, 0, 200, 0.6)',
                drawPoseLineWidth: 5*outputCanvasWH_mult/40,
                drawPoseRectColor: 'rgba(255, 255, 255, 0.5)',
                drawPoseRectLineWidth: outputCanvasWH_mult/40,
                startStopButtonDisabled: false,
                speedLineChartData: {
                    datasets: [
                        {
                            fill: false,
                            label: 'Legs',
                            data: [],
                            borderColor: 'rgba(75, 192, 192, 0.8)',
                        },
                        {
                            fill: false,
                            label: 'Back',
                            data: [],
                            borderColor: 'rgba(54, 162, 235, 0.8)',
                        },
                        {
                            fill: false,
                            label: 'Arms',
                            data: [],
                            borderColor: 'rgba(255, 99, 132, 0.8)',
                        },
                        {
                            fill: false,
                            label: 'Handle',
                            data: [],
                            borderColor: 'rgba(200, 200, 200, 0.8)',
                        }
                    ],

                },
                speedLineChartOptions: {
                    scales: {
                        xAxes: [
                            {
                                gridLines: {
                                    display: false
                                },
                                type: 'linear',
                                position: 'bottom',
                                ticks: {
                                    display: false,
                                    min: -0.02,
                                    max: 1.02
                                }
                            }
                        ],
                        yAxes: [
                            {
                                type: 'linear',
                                position: 'bottom',
                                ticks: {
                                    display: false,
                                    min: -0.02,
                                    max: 1.02
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ]
                    },
                    legend: {
                        display: false
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    forceHeight: 250,
                    title: {
                        display: true,
                        text: 'Body Parts Speed curves'
                    },
                    animation: {
                        duration: 800,
                    },
                    elements: {
                        point: {
                            radius: 0
                        }
                    },
                    tooltips: {
                        enabled: false
                    }
                },
                handleTrajectoryLineChartData: {
                    datasets: [
                        {
                            fill: false,
                            data: [],
                            borderColor: 'rgba(200, 200, 200, 0.8)',
                        },
                        {
                            fill: false,
                            data: [],
                            borderColor: 'rgba(200, 200, 200, 0.8)',
                        }
                    ],

                },
                handleTrajectoryLineChartOptions: {
                    scales: {
                        xAxes: [
                            {
                                gridLines: {
                                    display: false
                                },
                                type: 'linear',
                                position: 'bottom',
                                ticks: {
                                    max: 1.11,
                                    min: -0.11,
                                    display: false
                                },
                            }
                        ],
                        yAxes: [
                            {
                                type: 'linear',
                                position: 'bottom',
                                ticks: {
                                    max: 1.11,
                                    min: -0.11,
                                    display: false

                                },
                                gridLines: {
                                    display: false
                                },
                            }
                        ]
                    },
                    legend: {
                        display: false
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    title: {
                        display: true,
                        text: 'Handle trajectory'
                    },
                    animation: {
                        duration: 800,
                    },
                    elements: {
                        point: {
                            radius: 0
                        }
                    },
                    forceHeight: 250,
                    tooltips: {
                        enabled: false
                    }
                },
                scorePieChartDriveLbSeparationData,
                scorePieChartDriveLbSeparationOptions,
                scorePieChartDriveBaSeparationData,
                scorePieChartDriveBaSeparationOptions,
                scorePieChartDriveLbSeparationAvgData,
                scorePieChartDriveLbSeparationAvgOptions,
                LegsSegmentColor: 'rgba(75, 192, 192, 1)',
                BackSegmentColor: 'rgba(54, 162, 235, 1)',
                ArmsSegmentColor: 'rgba(255, 99, 132, 1)',
                hatchingColor: 'rgba(249, 177, 21, 1)',
                LegsSegmentStart: 0,
                LegsSegmentEnd: 0,
                BackSegmentStart: 0,
                BackSegmentEnd: 0,
                ArmsSegmentStart: 0,
                ArmsSegmentEnd: 0,
                LegsSegmentStartFixDuration: 0,
                LegsSegmentEndFixDuration: 0,
                BackSegmentStartFixDuration: 0,
                BackSegmentEndFixDuration: 0,
                ArmsSegmentStartFixDuration: 0,
                ArmsSegmentEndFixDuration: 0,
                LegsSegmentOkFlag: false,
                BackSegmentOkFlag: false,
                ArmsSegmentOkFlag: false,
                LegsSegmentTip: '—',
                BackSegmentTip: '—',
                ArmsSegmentTip: '—',
                mainSegmentTip: '—',
                mainSegmentTipSlug: null,
                rowerSide: store.myUser.onlineTrainingSetDefaultSideToLeft ? 'l' : null,
                rowerSideEncounterMirror: null,
                forwardAnglePos: null,
                laybackAnglePos: null,
                shinsAnglePos: null,

                crossfitSquatsCount: 0,
                crossfitSquatsCountTarget: null,
                crossfitPushupsCount: 0,
                crossfitPushupsCountTarget: null,
                crossfitBurpeesCount: 0,
                crossfitBurpeesCountTarget: null,

                isCameraDevice: true,
                isDisplayDevice: true,

                rowingIsFullscreenFlag: false,
                durationStr: '00:00.00',
                trainingDurationHandle: null,
                trainingStartedTs: null,

                rowingFullscreenGuiBurgerActive: false,
                rowingFullscreenVideoSwapped:  false,
                rowingTrainingVideoInBasicModeVisible: true,

                muteTrainingVideo: false,
                displayMediaStream: null,
                displayMediaCapture: null,
                sceenPhotoUploadingAxiosCancelTokenSource: null,
                sceenPhotoUploadingWidth: 1920/2,
                sceenPhotoUploadingHeight: 1080/2,
                grabScreenPhotoTimeoutHandle: null,
                screenCaptureVideoDom: null,
                screenCaptureCanvasDom: null,
                screenCaptureStreamWH: null
            }
        },
        methods: {
            async startStopTraining() {
                let trainingStarted = this.trainingStarted
                this.trainingStarted = !this.trainingStarted
                if (!trainingStarted)
                    this.$nextTick(this.startTraining)
                else
                    {
                        await this.stopTraining()
                        // if (this.isTouchDevice)
                        location.reload() // for resetting viewport. Because if it is not - subsequent manipulations with it doesn't work
                    }
            },
            async setInitialCurrentMediaStreamAndCameraInfos() {
                try {
                    let devices = await navigator.mediaDevices.enumerateDevices()
                    if (devices.length === 0 || !devices[0]['label']) {
                        await this.setCurrentMediaStream() // possibly enumerate donnt work or give label at some devices if hasn't requested stream
                        devices = await navigator.mediaDevices.enumerateDevices()
                    }
                    this.cameraInfos = devices.filter(device => device.kind === 'videoinput')
                    if (!this.cameraInfos.length)
                        // noinspection ExceptionCaughtLocallyJS
                        throw Error('No cameras found')
                } catch (e) {
                    this.errorText = "The camera is not available. Camera access is restricted, it is used in other apps, or your browser doesn't support access to it."
                    throw e
                }
            },
            async setCurrentMediaStream(cameraId) {
                let videoQuery = {frameRate: {ideal: 25, max: 30}}
                videoQuery['height'] = {ideal: 720, max: 720}
                videoQuery['width'] = {ideal: 1280, max: 1280}
                if (cameraId !== undefined) {
                    videoQuery['deviceId'] = cameraId
                }
                const constraints = {
                    'video': videoQuery,
                    'audio': false
                }
                this.currentMediaStream = await navigator.mediaDevices.getUserMedia(constraints)
                let videoTrackSettings = this.currentMediaStream.getVideoTracks()[0].getSettings()

                this.videoWH = [videoTrackSettings.width, videoTrackSettings.height]
                this.videoFPS = videoTrackSettings.frameRate
                this.clientDropout2Interval = 1/this.videoFPS * 2 * 0.7

                let aspectRatio = this.videoWH[0]/this.videoWH[1]
                if (aspectRatio < 1.7 || aspectRatio > 1.8)
                    this.addOnVideoMessage('wrong_aspect_ratio_warning', "Can't set needed camera settings. Try other device or browser. Analysis may be inaccurate")

                this.isUserFacingCamera = videoTrackSettings.facingMode === 'user'
                printSeparated(this.isUserFacingCamera)
            },
            async setupCameraByInfo(cameraInfo) {
                if (!(this.currentMediaStream && this.currentMediaStream.getVideoTracks()[0].getSettings().deviceId === cameraInfo.deviceId)) {
                    this.releaseCurrentMediaStreamIfExists()
                    await this.setCurrentMediaStream(cameraInfo.deviceId)
                }
                await this.setupCameraByCurrentMediaStream()
            },
            async setupCameraByCurrentMediaStream() {
                this.videoDom.width = this.videoWH[0]
                this.videoDom.height = this.videoWH[1]
                this.videoDom.srcObject = this.currentMediaStream
                // await new Promise((resolve) => {
                //     this.videoDom.onloadedmetadata = () => {
                //         resolve(this.videoDom)
                //     }
                // })  garbage code
                await this.videoDom.play()
                this.cameraSetFlag = true
            },
            releaseCurrentMediaStreamIfExists() {
                if (this.currentMediaStream) {
                    const tracks = this.currentMediaStream.getTracks()
                    tracks.forEach(track => track.stop())
                    this.currentMediaStream = null
                }
            },
            stopProcessingByHandle() {
                if (this.frameCaptureHandle !== null) {
                    if (this.requestVideoFrameCallbackAvailable)
                        { // noinspection JSUnresolvedFunction
                            this.videoDom.cancelVideoFrameCallback(this.frameCaptureHandle)
                        }
                    else
                        clearInterval(this.frameCaptureHandle)
                    this.frameCaptureHandle = null
                }
            },
            addOnVideoMessage(slug, text, isInfoFlag) {
                let onVideoMessages = {...this.onVideoMessages}
                onVideoMessages[slug] = [text, isInfoFlag]
                this.onVideoMessages = onVideoMessages
            },
            deleteOnVideoMessage(slug) {
                if (slug in this.onVideoMessages) {
                    let newMessages = {...this.onVideoMessages}
                    delete newMessages[slug]
                    this.onVideoMessages = newMessages
                }
            },
            async stopTraining() {
                this.releaseCurrentMediaStreamIfExists()
                this.stopProcessingByHandle()
                this.deviceMode = store.myUser.onlineTrainingAllowTwoDeviceSetup ? null : 'camera_and_display'
                this.readyForVideoStream = false
                this.videoStreamProcessingStarted = false
                this.processingWorkflowStartTs = null
                this.errorText = null
                this.onVideoMessages = {}
                this.settingsSetPartiallyFlag = null
                this.settingsSetFlag = null
                this.cameraSetFlag = null
                this.isUserFacingCamera = null
                this.debugShowPosesAllTimeFlag = false
                this.currentMediaStream = null
                this.cameraInfos = []
                this.videoWH = null
                this.videoFPS = null
                this.clientDropout2Interval = null
                this.lastCapturedJpg = null
                this.showSpinnerOnVideo = false
                this.bufferCanvas = null
                this.buffer2dCtx = null
                this.outputCanvas = null
                this.output2dCtx = null
                this.videoDom = null

                if (this.synchVideoRequest)
                    this.synchVideoRequest.abort()

                this.synchVideoRequest = null

                if (this.coachVideoRequest)
                    this.coachVideoRequest.abort()
                this.coachVideoRequest = null

                if (this.socket) {
                    this.socket.close()
                    if (this.simplePeerToServer) {
                        this.simplePeerToServer.destroy()
                    }
                    if (this.simplePeerToDisplay) {
                        this.simplePeerToDisplay.destroy()
                    }
                    if (this.simplePeerFromCamera) {
                        this.simplePeerFromCamera.destroy()
                    }
                }
                this.socket = null
                this.socketHandhsakeStatus = null
                this.webrtcToServerConnectionSuccessful = null
                this.simplePeerToServer = null
                this.webrtcToDisplayConnectionSuccessful = null
                this.simplePeerToDisplay = null
                this.webrtcFromCameraConnectionSuccessful = null
                this.simplePeerFromCamera = null

                if (this.stats && this.stats.dom)
                    this.stats.dom.remove()
                this.stats = null

                this.coachVideoRequest = null
                this.coachVideoDownloadProgress = null
                this.coachVideoReady = false
                this.coachVideoDom = null
                this.coachVideoTimeoutHandle = null

                this.rowingTrainingMode = 'basic'
                this.synchVideo = initalSynchVideo
                this.trainingVideo = initalTrainingVideo
                this.synchLevel = 1
                this.synchVideoSeat = 1
                this.synchVideoDownloadProgress = null
                this.synchVideoDom = null
                this.synchVideoRequest = null
                this.synchSpm = null
                this.synchSpmMetrics = 0
                this.synchCatchDiffMs = null
                this.synchFinishDiffMs = null
                this.synchRhythmActorStrokeNum = null
                this.synchDriveDuration = null
                this.synchRecoveryDuration = null
                this.synchStrokeNum = null
                this.synchRhythmMetrics = 0
                this.synchRhythmStrokePercent = null
                this.synchRhythmMatchedStrokeCount = 0
                this.synchRhythmTop = null
                this.synchRhythmTip = ''
                this.synchRhythmTipSlug = null
                this.synchDrivePeriodEnd = null
                this.synchActorDrivePeriodEnd = null
                this.synchLaybackAngle = null
                this.synchForwardAngle = null
                this.synchShinsAngle = null
                this.synchLbSeparation = null
                this.synchBaSeparation = null
                this.synchTechniqueMetrics = 0
                this.synchVideoIsPlaying = false
                if (this.synchTsSenderHandle) {
                    clearInterval(this.synchTsSenderHandle)
                    this.synchTsSenderHandle = null
                }

                this.basicTechniqueStrokePercent = null
                this.basicTechniqueGoodStrokeCount = 0
                this.basicTechniqueTop = null

                this.cameraStreamShowInCornerMode = false
                this.coachSwitchFlag = true
                this.strokeCount = 0
                this.strokeCountLastRowingPeriod = 0
                this.checkedStrokeCountBasicMode = 0
                this.checkedStrokeCountProMode = 0
                this.checkedStrokeCountSynchMode = 0
                this.analyzedStrokeCount = 0
                this.strokeCountInCircle = null
                this.strokeText = 'Ready?'
                this.spm = null
                this.maxSpm = null
                this.driveDuration = null
                this.recoveryDuration = null
                this.laybackAngle = null
                this.forwardAngle = null
                this.shinsAngle = null
                this.lbSeparation = null
                this.baSeparation = null
                this.lbSeparationAvg = null
                this.lbSeparationOkFlag = null
                this.baSeparationOkFlag = null
                this.lbSeparationAvgOkFlag = null
                this.lastRegularFrameClientTs = null
                this.clientDropout = store.myUser.onlineTrainingDoDropoutOnWebsocketVideoClient ? 2 : null
                this.regularFrameNum = 0
                this.tableData = [
                    [],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [],
                ]

                this.handleTrajectoryLineChartData.datasets[0].data = []
                this.handleTrajectoryLineChartData.datasets[0].borderColor = 'rgba(200, 200, 200, 0.8)'
                this.handleTrajectoryLineChartData.datasets[1].data = []
                this.handleTrajectoryLineChartData.datasets[1].borderColor = 'rgba(200, 200, 200, 0.8)'
                this.handleTrajectoryLineChartData = {...this.handleTrajectoryLineChartData}

                this.speedLineChartData.datasets[0].data = []
                this.speedLineChartData.datasets[0].borderColor = 'rgba(75, 192, 192, 0.8)'
                this.speedLineChartData.datasets[1].data = []
                this.speedLineChartData.datasets[1].borderColor = 'rgba(54, 162, 235, 0.8)'
                this.speedLineChartData.datasets[2].data = []
                this.speedLineChartData.datasets[2].borderColor = 'rgba(255, 99, 132, 0.8)'
                this.speedLineChartData.datasets[3].data = []
                this.speedLineChartData.datasets[3].borderColor = 'rgba(200, 200, 200, 0.8)'
                this.speedLineChartData = {...this.speedLineChartData}

                this.scorePieChartDriveLbSeparationData.datasets[0].data = [0, 100]
                this.scorePieChartDriveLbSeparationData.datasets[0].backgroundColor = [
                    "rgba(26, 132, 57, 0.6)",
                    "rgba(0,0,0,0)",
                ]
                this.scorePieChartDriveLbSeparationData.datasets[0].borderColor = [
                    "rgba(26, 132, 57, 1)",
                    "rgba(0,0,0,0)",
                ]
                this.scorePieChartDriveLbSeparationData = {...this.scorePieChartDriveLbSeparationData}

                this.scorePieChartDriveBaSeparationData.datasets[0].data = [0, 100]
                this.scorePieChartDriveBaSeparationData.datasets[0].backgroundColor = [
                    "rgba(26, 132, 57, 0.6)",
                    "rgba(0,0,0,0)",
                ]
                this.scorePieChartDriveBaSeparationData.datasets[0].borderColor = [
                    "rgba(26, 132, 57, 1)",
                    "rgba(0,0,0,0)",
                ]
                this.scorePieChartDriveBaSeparationData = {...this.scorePieChartDriveBaSeparationData}

                this.scorePieChartDriveLbSeparationAvgData.datasets[0].data = [0, 100]
                this.scorePieChartDriveLbSeparationAvgData.datasets[0].backgroundColor = [
                    "rgba(26, 132, 57, 0.6)",
                    "rgba(0,0,0,0)",
                ]
                this.scorePieChartDriveLbSeparationAvgData.datasets[0].borderColor = [
                    "rgba(26, 132, 57, 1)",
                    "rgba(0,0,0,0)",
                ]
                this.scorePieChartDriveLbSeparationAvgData = {...this.scorePieChartDriveLbSeparationAvgData}

                this.LegsSegmentColor = 'rgba(75, 192, 192, 1)'
                this.BackSegmentColor = 'rgba(54, 162, 235, 1)'
                this.ArmsSegmentColor = 'rgba(255, 99, 132, 1)'
                this.hatchingColor = 'rgba(249, 177, 21, 1)'
                this.LegsSegmentStart = 0
                this.LegsSegmentEnd = 0
                this.BackSegmentStart = 0
                this.BackSegmentEnd = 0
                this.ArmsSegmentStart = 0
                this.ArmsSegmentEnd = 0
                this.LegsSegmentStartFixDuration = 0
                this.LegsSegmentEndFixDuration = 0
                this.BackSegmentStartFixDuration = 0
                this.BackSegmentEndFixDuration = 0
                this.ArmsSegmentStartFixDuration = 0
                this.ArmsSegmentEndFixDuration = 0
                this.LegsSegmentOkFlag = false
                this.BackSegmentOkFlag = false
                this.ArmsSegmentOkFlag = false
                this.LegsSegmentTip = '—'
                this.BackSegmentTip = '—'
                this.ArmsSegmentTip = '—'
                this.mainSegmentTip = '—'
                this.mainSegmentTipSlug = null
                this.rowerSide = store.myUser.onlineTrainingSetDefaultSideToLeft ? 'l' : null
                this.rowerSideEncounterMirror = null
                this.forwardAnglePos = null
                this.laybackAnglePos = null
                this.shinsAnglePos = null

                this.crossfitSquatsCount = 0
                this.crossfitSquatsCountTarget = null
                this.crossfitPushupsCount = 0
                this.crossfitPushupsCountTarget = null
                this.crossfitBurpeesCount = 0
                this.crossfitBurpeesCountTarget = null
                this.crossfitTrainingConfig = null

                this.rowingIsFullscreenFlag = false
                if (this.trainingDurationHandle) {
                    clearInterval(this.trainingDurationHandle)
                    this.trainingDurationHandle = null
                }
                this.trainingStartedTs = null
                this.durationStr = '00:00.00'

                this.rowingFullscreenGuiBurgerActive = false
                this.rowingFullscreenVideoSwapped = false
                this.rowingTrainingVideoInBasicModeVisible = true
                this.wideScreenOff()

                if (this.displayMediaStream) {
                    const tracks = this.displayMediaStream.getTracks()
                    tracks.forEach(track => track.stop())
                    this.displayMediaStream = null
                }
                this.displayMediaCapture = null

                if (this.sceenPhotoUploadingAxiosCancelTokenSource)
                    this.sceenPhotoUploadingAxiosCancelTokenSource.cancel()
                this.sceenPhotoUploadingAxiosCancelTokenSource = null

                if (this.grabScreenPhotoTimeoutHandle) {
                    clearTimeout(this.grabScreenPhotoTimeoutHandle)
                    this.grabScreenPhotoTimeoutHandle = null
                }

                this.screenCaptureVideoDom = null
                this.screenCaptureCanvasDom = null
                this.screenCaptureStreamWH = null
            },
            async startTraining() {
                this.startStopButtonDisabled = true
                this.preloadCoachVideo()

                try {
                    if (!await this.setupWebsockets())
                        return
                    this.startStopButtonDisabled = false


                    if (this.trainingMode === 'rowing' && this.store.myUser.onlineTrainingDoScreenPhotosExhibitionMode) {
                        this.screenCaptureVideoDom = document.getElementById('exhibition_photo_screen_video')
                        this.screenCaptureCanvasDom = document.getElementById('exhibition_photo_canvas')
                        // noinspection JSUnresolvedFunction
                        navigator.mediaDevices.getDisplayMedia().then(stream =>
                        {
                            this.displayMediaStream = stream
                            let videoTrackSettings = this.displayMediaStream.getVideoTracks()[0].getSettings()
                            this.screenCaptureStreamWH = [videoTrackSettings.width, videoTrackSettings.height]

                            this.screenCaptureVideoDom.srcObject = this.displayMediaStream

                        })
                            .catch(e => {this.errorText="Can't get display stream"; throw e});
                        while (!this.displayMediaStream)
                            await sleep(300)
                    }

                    if (this.isCameraDevice && this.store.myUser.isSuperuser)
                        this.setupFPS()

                    while (!this.isLandscapeOrientation) {
                        await sleep(300)
                        if (!this.trainingStarted)
                            return
                    }
                    if (this.isDisplayDevice && this.trainingMode === 'crossfit')
                        while (!this.crossfitTrainingConfig) {
                            await sleep(300)
                            if (!this.trainingStarted)
                                return
                        }

                    this.videoDom = document.getElementsByClassName('online-training-video')[0]
                    let trainingConfig

                    if (this.isDisplayDevice) {
                        this.outputCanvas = document.getElementsByClassName('online-training-output')[0]
                        this.output2dCtx = this.outputCanvas.getContext('2d')
                        this.outputCanvas.width = this.outputCanvasWH[0]
                        this.outputCanvas.height = this.outputCanvasWH[1]

                        trainingConfig = this.trainingMode === 'crossfit' ? this.crossfitTrainingConfig : null
                    }

                    if (this.isCameraDevice) {
                        await this.setInitialCurrentMediaStreamAndCameraInfos()
                        if (this.cameraInfos.length === 1)
                            await this.setupCameraByCurrentMediaStream()
                        while (!this.cameraSetFlag) {
                            await sleep(300)
                            if (!this.trainingStarted)
                                return
                        }
                    }

                    this.readyForVideoStream = true
                    this.showSpinnerOnVideo = true
                    this.wideScreenOn()

                    if (this.deviceMode === 'camera_and_display') {
                        this.sendWebsocketMsg({
                            event: 'set_settings',
                            fps: this.videoFPS,
                            request_video_frame_callback_available: this.requestVideoFrameCallbackAvailable,
                            training_config: trainingConfig
                        })
                        while (!this.settingsSetFlag) {
                            await sleep(300)
                            if (!this.trainingStarted)
                                return
                        }
                        if (!this.store.myUser.onlineTrainingDoNotUseWebRtcForSingleDeviceMode) {
                            await this.setupWebrtcToServerVideoTransfer()
                            if (!this.webrtcToServerConnectionSuccessful)
                                this.setupWebSocketsVideoTransfer()
                        } else
                            this.setupWebSocketsVideoTransfer()
                        this.showSpinnerOnVideo = false
                        this.videoStreamProcessingStarted = true
                    }
                    else if (this.deviceMode === 'camera') {
                        this.sendWebsocketMsg({
                            event: 'set_settings',
                            fps: this.videoFPS,
                            request_video_frame_callback_available: this.requestVideoFrameCallbackAvailable
                        })
                        while (!this.settingsSetPartiallyFlag) {
                            await sleep(300)
                            if (!this.trainingStarted)
                                return
                        }
                        this.addOnVideoMessage('looking_for_display_device', 'Looking for display device...', true)
                    }
                    else if (this.deviceMode === 'display') {
                        this.setupWebrtcFromCameraVideoTransfer()
                        this.sendWebsocketMsg({
                            event: 'set_settings',
                            training_config: trainingConfig
                        })
                        while (!this.settingsSetPartiallyFlag) {
                            await sleep(300)
                            if (!this.trainingStarted)
                                return
                        }
                        this.addOnVideoMessage('looking_for_camera_device', 'Looking for camera device...', true)
                        if (this.trainingMode === 'rowing')
                            this.setRowerSideEncounterMirror()
                    }
                    this.$nextTick(this.preloadAndRunTrainingVideo)
                } finally {
                    this.startStopButtonDisabled = false
                }
            },
            runProcessingStep() {
                if(!document.hidden)
                    try {
                        // let start = +new Date
                        // printSeparated('0', (+new Date) - start)

                        this.stats && this.stats.begin()
                        let clientTs = performance.now()/1000
                        let synchTs = this.synchVideoIsPlaying ? this.synchVideoDom.currentTime : null
                        let jpegQuality = 0.75
                        let dropFrameFlag
                        // noinspection JSIncompatibleTypesComparison
                        if (this.clientDropout === null || this.lastRegularFrameClientTs === null || !store.myUser.onlineTrainingDoDropoutOnWebsocketVideoClient ||
                            (this.clientDropout === 3 && this.regularFrameNum % 2)) // dropout logic is strange and hard. maybe bugs. Probably it works not for low network (nott needed) but for low speed client frame scan
                            dropFrameFlag = false
                        else {
                            dropFrameFlag = (clientTs - this.lastRegularFrameClientTs) < this.clientDropout2Interval
                        }
                        let frameStr
                        let frameStatus

                        if (this.requestVideoFrameCallbackAvailable) {
                            // noinspection JSUnresolvedFunction
                            this.videoDom.requestVideoFrameCallback(this.runProcessingStep)
                            if (dropFrameFlag) {
                                frameStr = null
                                frameStatus = 'dropped_frame_on_client'
                            }
                            else {
                                this.buffer2dCtx.drawImage(this.videoDom, 0, 0, this.canvasSenderWH[0], this.canvasSenderWH[1])
                                frameStr = this.bufferCanvas.toDataURL('image/jpeg', jpegQuality)
                                frameStatus = 'regular_frame'
                                this.lastRegularFrameClientTs = clientTs
                                this.regularFrameNum += 1
                            }
                            this.sendWebsocketMsg({event: 'frame', frame_str: frameStr, frame_ts: clientTs, frame_status: frameStatus, synch_ts: synchTs})
                            this.stats && this.stats.end()
                        }
                        else {
                            this.buffer2dCtx.drawImage(this.videoDom, 0, 0, this.canvasSenderWH[0], this.canvasSenderWH[1])
                            frameStr = this.bufferCanvas.toDataURL('image/jpeg', jpegQuality)
                            if (frameStr !== this.lastCapturedJpg) {
                                this.lastCapturedJpg = frameStr
                                if (dropFrameFlag) {
                                    frameStr = null
                                    frameStatus = 'dropped_frame_on_client'
                                }
                                else {
                                    frameStatus = 'regular_frame'
                                    this.lastRegularFrameClientTs = clientTs
                                    this.regularFrameNum += 1
                                }
                                this.sendWebsocketMsg({event: 'frame', frame_str: frameStr, frame_ts: clientTs, frame_status: frameStatus, synch_ts: synchTs})
                                this.stats && this.stats.end()
                            }

                        if (this.socket.bufferedAmount > 0.26 * jpegQuality * this.canvasSenderWH[0] * this.canvasSenderWH[1] * 40)
                            this.addOnVideoMessage('slow_network', 'Your network connection is too slow')
                        else
                            this.deleteOnVideoMessage('slow_network')
                        }
                    } catch (e) {
                        if (this.frameCaptureHandle) {
                            this.stopProcessingByHandle()
                            throw e
                        }
                    }
                else if (this.requestVideoFrameCallbackAvailable)
                    { // noinspection JSUnresolvedFunction
                        this.videoDom.requestVideoFrameCallback(this.runProcessingStep)
                    }
            },
            drawPoses(poses, rects_contours) {
                this.output2dCtx.save()
                this.output2dCtx.clearRect(0, 0, this.outputCanvas.width, this.outputCanvas.height)
                for (let pose of poses) {
                    for (let point of Object.values(pose))
                        this.drawPoint(point, this.drawPoseLineWidth, this.drawPoseColor)
                    if (store.showStaffControls) {
                        let bones = [['l_hip', 'l_knee'], ['l_knee', 'l_ankle'], ['l_hip', 'l_shoulder'], ['l_shoulder', 'l_elbow'], ['l_elbow', 'l_wrist'], ['r_hip', 'r_knee'], ['r_knee', 'r_ankle'], ['r_hip', 'r_shoulder'], ['r_shoulder', 'r_elbow'], ['r_elbow', 'r_wrist']]
                        for (let bone of bones) {
                            if (bone[0] in pose && bone[1] in pose )
                                this.drawSegment(pose[bone[0]], pose[bone[1]], this.drawPoseLineWidth, this.drawPoseColor)
                        }
                    }
                }
                if (rects_contours)
                    for (let rect of rects_contours) {
                        this.drawSegment(rect[0], rect[1], this.drawPoseRectLineWidth, this.drawPoseRectColor)
                        this.drawSegment(rect[1], rect[2], this.drawPoseRectLineWidth, this.drawPoseRectColor)
                        this.drawSegment(rect[2], rect[3], this.drawPoseRectLineWidth, this.drawPoseRectColor)
                        this.drawSegment(rect[3], rect[0], this.drawPoseRectLineWidth, this.drawPoseRectColor)
                    }
                this.output2dCtx.restore()
            },
            drawPoint(point, r, color) {
                this.output2dCtx.beginPath()
                this.output2dCtx.arc(point[0], point[1], r, 0, 2 * Math.PI)
                this.output2dCtx.fillStyle = color
                this.output2dCtx.fill()
            },
            drawSegment(point1, point2, lineWidth,  color) {
                this.output2dCtx.beginPath()
                this.output2dCtx.moveTo(point1[0], point1[1])
                this.output2dCtx.lineTo(point2[0], point2[1])
                this.output2dCtx.lineWidth = lineWidth
                this.output2dCtx.strokeStyle = color
                this.output2dCtx.stroke()
            },
            async setupWebsockets() {
                this.socket = new WebSocket(websocketsURL + '/online-training')

                let processingMode
                if (this.deviceMode === 'camera')
                    processingMode = 'training_camera_mode'
                else if (this.deviceMode === 'display') {
                    if (this.trainingMode === 'rowing')
                        processingMode = 'rowing_training_display_mode'
                    else if (this.trainingMode === 'crossfit')
                        processingMode = 'crossfit_training_display_mode'
                }
                else if (this.deviceMode === 'camera_and_display') {
                    if (this.trainingMode === 'rowing')
                        processingMode = 'rowing_training_mode'
                    else if (this.trainingMode === 'crossfit')
                        processingMode = 'crossfit_training_mode'
                }

                this.socket.onopen = () => {
                    this.sendWebsocketMsg({
                        event: 'handshake',
                        processing_mode: processingMode,
                    })
                }

                this.socket.onclose = () => {
                    this.socket = null
                    if (this.trainingStarted)
                        if (this.readyForVideoStream)
                            this.addOnVideoMessage('socket_failed', WebsocketFailedTxt)
                        else
                            this.errorText = WebsocketFailedTxt
                    this.startStopButtonDisabled = false
                    this.stopProcessingByHandle()
                }

                this.socket.onerror = () => {
                    this.socket = null
                    if (this.trainingStarted)
                        if (this.readyForVideoStream)
                            this.addOnVideoMessage('socket_failed', WebsocketFailedTxt)
                        else
                            this.errorText = WebsocketFailedTxt
                    this.startStopButtonDisabled = false
                    this.stopProcessingByHandle()
                }

                this.socket.onmessage = (msg) => {
                    if (!msg.data)
                        return
                    let event = JSON.parse(msg.data)
                    this.onWebsocketEvent(event)
                }

                while (this.socket && !this.socketHandhsakeStatus) {
                    await sleep(300)
                    if (!this.trainingStarted)
                        return
                }

                if (this.socketHandhsakeStatus === 'no_free_slots') {
                    this.errorText = 'Too many clients connected to the real-time analysis server. Please, wait some time and try again'
                    return false
                }
                else if (this.socketHandhsakeStatus === 'already_running') {
                    if (this.deviceMode === 'camera')
                        this.errorText = 'Other camera device is already connected'
                    else if (this.deviceMode === 'display')
                        this.errorText = 'Other display device is already connected.'
                    return false
                }
                else if (!this.socket) {
                    this.errorText = WebsocketFailedTxt
                    return false
                }

                return true
            },
            async onWebsocketEvent (event) {
                if (event.event === 'handshake')
                    this.socketHandhsakeStatus = event.status
                else if (event.event === 'server_error') {
                    this.addOnVideoMessage('server_error', 'Server error')
                    this.stopProcessingByHandle()
                } else if (event.event === 'settings_set') {
                    this.settingsSetFlag = true
                    if (this.deviceMode === 'camera') {
                        this.deleteOnVideoMessage('looking_for_display_device')
                        this.addOnVideoMessage('connecting', 'Connecting...', true)
                        // noinspection ES6MissingAwait
                        this.setupWebrtcToServerVideoTransfer()
                        // noinspection ES6MissingAwait
                        this.setupWebrtcToDisplayVideoTransfer()
                    }
                    else if (this.deviceMode === 'display') {
                        this.deleteOnVideoMessage('looking_for_camera_device')
                        this.addOnVideoMessage('connecting', 'Connecting...', true)
                    }
                } else if (event.event === 'settings_set_partially') {
                    this.settingsSetPartiallyFlag = true
                }  else if (event.event === 'webrtc_from_server_reply_offer') {
                    this.simplePeerToServer.signal(event.val)
                } else if (event.event === 'webrtc_to_camera_signal') {
                    this.simplePeerToDisplay.signal(event.val)
                } else if (event.event === 'webrtc_to_display_signal') {
                    this.simplePeerFromCamera.signal(event.val)
                }
                else if (event.event === 'commands')
                    for (let command of event.commands) {
                        // printSeparated(command)
                        if (command.name === 'loading')
                            this.showSpinnerOnVideo = command.val
                        else if (command.name === 'missed_frames_on_client_warning' && !store.myUser.onlineTrainingHideSlowdownWarning) {
                            if (command.val)
                                this.addOnVideoMessage(command.name, 'The last stroke analysis was inaccurate due to missed frames.')
                            else
                                this.deleteOnVideoMessage(command.name)
                        }
                        else if (command.name === 'missed_frames_on_client_online_warning' && !store.myUser.onlineTrainingHideSlowdownWarning) {
                            if (command.val)
                                if (!this.webrtcToServerConnectionSuccessful)
                                    this.addOnVideoMessage(command.name, 'Your device slows down and misses frames. Try to add more light and close other tabs and programs. Analysis may be inaccurate')
                                else
                                    this.addOnVideoMessage(command.name, 'Your device slows down and misses frames. Try to add more light and close other tabs and programs, or check the speed of the network connection. Analysis may be inaccurate')
                            else
                                this.deleteOnVideoMessage(command.name)
                        }
                        else if (command.name === 'missed_frames_on_server_warning' && !store.myUser.onlineTrainingHideOtherWarnings) {
                            if (command.val)
                                this.addOnVideoMessage(command.name, 'The server slows down and misses frames. Admins were notified. Analysis may be inaccurate')
                            else
                                this.deleteOnVideoMessage(command.name)
                        }
                        else if (command.name === 'pose_2d_not_in_frame_with_padding_high_percent' && !store.myUser.onlineTrainingHideOtherWarnings) {
                            if (command.val)
                                this.addOnVideoMessage(command.name, 'The pose is not totally in the frame. Analysis may be inaccurate')
                            else
                                this.deleteOnVideoMessage(command.name)
                        }
                        else if (command.name === 'cant_find_human_at_many_frames_2d_warning' && !store.myUser.onlineTrainingHideOtherWarnings) {
                            if (command.val)
                                this.addOnVideoMessage(command.name, 'Human in the lateral and sitting position was not found' + ('missed_frames_on_client_warning' in this.onVideoMessages ? '' :  '. Check camera position'))
                            else
                                this.deleteOnVideoMessage(command.name)
                        }
                        else if (command.name === 'stroke_not_found' && !store.myUser.onlineTrainingHideOtherWarnings) {
                            if (command.val)
                                this.addOnVideoMessage(command.name, 'Stroke was not recognized well' + ('missed_frames_on_client_warning' in this.onVideoMessages ? '' :  '. Check camera position'))
                            else
                                this.deleteOnVideoMessage(command.name)
                        }
                        else if (command.name === 'small_pose_2d_median_back_length_pixels_warning' && !store.myUser.onlineTrainingHideOtherWarnings) {
                            if (command.val)
                                this.addOnVideoMessage(command.name, 'The athlete is too small. Put camera closer')
                            else
                                this.deleteOnVideoMessage(command.name)
                        }
                        else if (command.name === 'athlete_too_close' && !store.myUser.onlineTrainingHideOtherWarnings) {
                            if (command.val)
                                this.addOnVideoMessage(command.name, 'The athlete is quite close to the camera. Perspective distortions may do results inaccurate')
                            else
                                this.deleteOnVideoMessage(command.name)
                        }
                        else if (command.name === 'stroke_active') {
                            if (command.val) {
                                this.handleTrajectoryLineChartData.datasets[0].borderColor = 'rgba(200, 200, 200, 0.8)'
                                this.handleTrajectoryLineChartData.datasets[1].borderColor = 'rgba(200, 200, 200, 0.8)'
                                this.handleTrajectoryLineChartData = {...this.handleTrajectoryLineChartData}

                                this.speedLineChartData.datasets[0].borderColor = 'rgba(75, 192, 192, 0.8)'
                                this.speedLineChartData.datasets[1].borderColor = 'rgba(54, 162, 235, 0.8)'
                                this.speedLineChartData.datasets[2].borderColor = 'rgba(255, 99, 132, 0.8)'
                                this.speedLineChartData.datasets[3].borderColor = 'rgba(200, 200, 200, 0.8)'
                                this.speedLineChartData = {...this.speedLineChartData}

                                if (this.lbSeparationOkFlag || this.lbSeparationOkFlag === null) {
                                    this.scorePieChartDriveLbSeparationData.datasets[0].backgroundColor = [
                                        "rgba(26, 132, 57, 0.6)",
                                        "rgba(0,0,0,0)",
                                    ]
                                    this.scorePieChartDriveLbSeparationData.datasets[0].borderColor = [
                                        "rgba(26, 132, 57, 1)",
                                        "rgba(0,0,0,0)",
                                    ]
                                    this.scorePieChartDriveLbSeparationData = {...this.scorePieChartDriveLbSeparationData}
                                } else {
                                    this.scorePieChartDriveLbSeparationData.datasets[0].backgroundColor = [
                                        "rgba(249, 177, 21, 0.6)",
                                        "rgba(0,0,0,0)",
                                    ]
                                    this.scorePieChartDriveLbSeparationData.datasets[0].borderColor = [
                                        "rgba(249, 177, 21, 1)",
                                        "rgba(0,0,0,0)",
                                    ]
                                    this.scorePieChartDriveLbSeparationData = {...this.scorePieChartDriveLbSeparationData}
                                }


                                if (this.baSeparationOkFlag || this.baSeparationOkFlag === null) {
                                    this.scorePieChartDriveBaSeparationData.datasets[0].backgroundColor = [
                                        "rgba(26, 132, 57, 0.6)",
                                        "rgba(0,0,0,0)",
                                    ]
                                    this.scorePieChartDriveBaSeparationData.datasets[0].borderColor = [
                                        "rgba(26, 132, 57, 1)",
                                        "rgba(0,0,0,0)",
                                    ]
                                    this.scorePieChartDriveBaSeparationData = {...this.scorePieChartDriveBaSeparationData}
                                } else {
                                    this.scorePieChartDriveBaSeparationData.datasets[0].backgroundColor = [
                                        "rgba(249, 177, 21, 0.6)",
                                        "rgba(0,0,0,0)",
                                    ]
                                    this.scorePieChartDriveBaSeparationData.datasets[0].borderColor = [
                                        "rgba(249, 177, 21, 1)",
                                        "rgba(0,0,0,0)",
                                    ]
                                    this.scorePieChartDriveBaSeparationData = {...this.scorePieChartDriveBaSeparationData}
                                }

                                if (this.lbSeparationAvgOkFlag || this.lbSeparationAvgOkFlag === null) {
                                    this.scorePieChartDriveLbSeparationAvgData.datasets[0].backgroundColor = [
                                        "rgba(26, 132, 57, 0.6)",
                                        "rgba(0,0,0,0)",
                                    ]
                                    this.scorePieChartDriveLbSeparationAvgData.datasets[0].borderColor = [
                                        "rgba(26, 132, 57, 1)",
                                        "rgba(0,0,0,0)",
                                    ]
                                    this.scorePieChartDriveLbSeparationAvgData = {...this.scorePieChartDriveLbSeparationAvgData}
                                } else {
                                    this.scorePieChartDriveLbSeparationAvgData.datasets[0].backgroundColor = [
                                        "rgba(249, 177, 21, 0.6)",
                                        "rgba(0,0,0,0)",
                                    ]
                                    this.scorePieChartDriveLbSeparationAvgData.datasets[0].borderColor = [
                                        "rgba(249, 177, 21, 1)",
                                        "rgba(0,0,0,0)",
                                    ]
                                    this.scorePieChartDriveLbSeparationAvgData = {...this.scorePieChartDriveLbSeparationAvgData}
                                }

                                this.LegsSegmentColor = 'rgba(75, 192, 192, 1)'
                                this.BackSegmentColor = 'rgba(54, 162, 235, 1)'
                                this.ArmsSegmentColor = 'rgba(255, 99, 132, 1)'

                                this.hatchingColor = 'rgba(249, 177, 21, 1)'
                            } else {
                                this.handleTrajectoryLineChartData.datasets[0].borderColor = 'rgba(200, 200, 200, 0.4)'
                                this.handleTrajectoryLineChartData.datasets[1].borderColor = 'rgba(200, 200, 200, 0.4)'
                                this.handleTrajectoryLineChartData = {...this.handleTrajectoryLineChartData}

                                this.speedLineChartData.datasets[0].borderColor = 'rgba(75, 192, 192, 0.4)'
                                this.speedLineChartData.datasets[1].borderColor = 'rgba(54, 162, 235, 0.4)'
                                this.speedLineChartData.datasets[2].borderColor = 'rgba(255, 99, 132, 0.4)'
                                this.speedLineChartData.datasets[3].borderColor = 'rgba(200, 200, 200, 0.4)'
                                this.speedLineChartData = {...this.speedLineChartData}

                                if (this.lbSeparationOkFlag) {
                                    this.scorePieChartDriveLbSeparationData.datasets[0].backgroundColor = [
                                        "rgba(26, 132, 57, 0.4)",
                                        "rgba(0,0,0,0)",
                                    ]
                                    this.scorePieChartDriveLbSeparationData.datasets[0].borderColor = [
                                        "rgba(26, 132, 57, 1)",
                                        "rgba(0,0,0,0)",
                                    ]
                                    this.scorePieChartDriveLbSeparationData = {...this.scorePieChartDriveLbSeparationData}
                                } else {
                                    this.scorePieChartDriveLbSeparationData.datasets[0].backgroundColor = [
                                        "rgba(249, 177, 21, 0.4)",
                                        "rgba(0,0,0,0)",
                                    ]
                                    this.scorePieChartDriveLbSeparationData.datasets[0].borderColor = [
                                        "rgba(249, 177, 21, 1)",
                                        "rgba(0,0,0,0)",
                                    ]
                                    this.scorePieChartDriveLbSeparationData = {...this.scorePieChartDriveLbSeparationData}
                                }


                                if (this.baSeparationOkFlag) {
                                    this.scorePieChartDriveBaSeparationData.datasets[0].backgroundColor = [
                                        "rgba(26, 132, 57, 0.4)",
                                        "rgba(0,0,0,0)",
                                    ]
                                    this.scorePieChartDriveBaSeparationData.datasets[0].borderColor = [
                                        "rgba(26, 132, 57, 1)",
                                        "rgba(0,0,0,0)",
                                    ]
                                    this.scorePieChartDriveBaSeparationData = {...this.scorePieChartDriveBaSeparationData}
                                } else {
                                    this.scorePieChartDriveBaSeparationData.datasets[0].backgroundColor = [
                                        "rgba(249, 177, 21, 0.4)",
                                        "rgba(0,0,0,0)",
                                    ]
                                    this.scorePieChartDriveBaSeparationData.datasets[0].borderColor = [
                                        "rgba(249, 177, 21, 1)",
                                        "rgba(0,0,0,0)",
                                    ]
                                    this.scorePieChartDriveBaSeparationData = {...this.scorePieChartDriveBaSeparationData}
                                }

                                if (this.lbSeparationAvgOkFlag) {
                                    this.scorePieChartDriveLbSeparationAvgData.datasets[0].backgroundColor = [
                                        "rgba(26, 132, 57, 0.4)",
                                        "rgba(0,0,0,0)",
                                    ]
                                    this.scorePieChartDriveLbSeparationAvgData.datasets[0].borderColor = [
                                        "rgba(26, 132, 57, 1)",
                                        "rgba(0,0,0,0)",
                                    ]
                                    this.scorePieChartDriveLbSeparationAvgData = {...this.scorePieChartDriveLbSeparationAvgData}
                                } else {
                                    this.scorePieChartDriveLbSeparationAvgData.datasets[0].backgroundColor = [
                                        "rgba(249, 177, 21, 0.4)",
                                        "rgba(0,0,0,0)",
                                    ]
                                    this.scorePieChartDriveLbSeparationAvgData.datasets[0].borderColor = [
                                        "rgba(249, 177, 21, 1)",
                                        "rgba(0,0,0,0)",
                                    ]
                                    this.scorePieChartDriveLbSeparationAvgData = {...this.scorePieChartDriveLbSeparationAvgData}
                                }

                                this.LegsSegmentColor = 'rgba(75, 192, 192, 0.7)'
                                this.BackSegmentColor = 'rgba(54, 162, 235, 0.7)'
                                this.ArmsSegmentColor = 'rgba(255, 99, 132, 0.7)'

                                this.hatchingColor = 'rgba(249, 177, 21, 0.7)'
                            }
                        }
                        else if (command.name === 'stroke') {
                            this.rowerSide = command.rower_side
                            this.setRowerSideEncounterMirror()

                            this.lbSeparation = command.lb_separation
                            this.lbSeparationOkFlag = command.lb_separation_ok_flag
                            this.baSeparation = command.ba_separation
                            this.baSeparationOkFlag = command.ba_separation_ok_flag
                            this.lbSeparationAvg = command.lb_separation_avg
                            this.lbSeparationAvgOkFlag = command.lb_separation_avg_ok_flag

                            this.scorePieChartDriveLbSeparationData.datasets[0].data = [this.lbSeparation, 100 - this.lbSeparation ]
                            this.scorePieChartDriveLbSeparationData = {...this.scorePieChartDriveLbSeparationData}

                            this.scorePieChartDriveBaSeparationData.datasets[0].data = [this.baSeparation, 100 - this.baSeparation]
                            this.scorePieChartDriveBaSeparationData = {...this.scorePieChartDriveBaSeparationData}

                            this.scorePieChartDriveLbSeparationAvgData.datasets[0].data = [this.lbSeparationAvg, 100 - this.lbSeparationAvg]
                            this.scorePieChartDriveLbSeparationAvgData = {...this.scorePieChartDriveLbSeparationAvgData}

                            this.handleTrajectoryLineChartData.datasets[0].data = command.handle_drive_trajectory
                            this.handleTrajectoryLineChartData.datasets[1].data = command.handle_recovery_trajectory
                            this.handleTrajectoryLineChartData = {...this.handleTrajectoryLineChartData}
                            if (this.isUserFacingCamera) {
                                for (let item of this.handleTrajectoryLineChartData.datasets[0].data)
                                    item['x'] = 1 - item['x']
                                for (let item of this.handleTrajectoryLineChartData.datasets[1].data)
                                    item['x'] = 1 - item['x']
                            }

                            this.speedLineChartData.datasets[0].data = command.legs_speed_curve
                            this.speedLineChartData.datasets[1].data = command.back_speed_curve
                            this.speedLineChartData.datasets[2].data = command.arms_speed_curve
                            this.speedLineChartData.datasets[3].data = command.handle_speed_curve
                            this.speedLineChartData = {...this.speedLineChartData}

                            this.LegsSegmentStart = command.legs_period_start
                            this.BackSegmentStart = command.back_period_start
                            this.ArmsSegmentStart = command.arms_period_start

                            this.LegsSegmentEnd = command.legs_period_end
                            this.BackSegmentEnd = command.back_period_end
                            this.ArmsSegmentEnd = command.arms_period_end

                            this.LegsSegmentStartFixDuration = command.legs_period_start_fix_duration
                            this.BackSegmentStartFixDuration = command.back_period_start_fix_duration
                            this.ArmsSegmentStartFixDuration = command.arms_period_start_fix_duration

                            this.LegsSegmentEndFixDuration = command.legs_period_end_fix_duration
                            this.BackSegmentEndFixDuration = command.back_period_end_fix_duration
                            this.ArmsSegmentEndFixDuration = command.arms_period_end_fix_duration

                            this.LegsSegmentOkFlag = command.legs_period_ok_flag
                            this.BackSegmentOkFlag = command.back_period_ok_flag
                            this.ArmsSegmentOkFlag = command.arms_period_ok_flag

                            this.LegsSegmentTip = command.legs_period_tip
                            this.BackSegmentTip = command.back_period_tip
                            this.ArmsSegmentTip = command.arms_period_tip

                            this.mainSegmentTip = command.main_period_tip

                            if (this.rowingTrainingMode === 'basic' && this.mainSegmentTipSlug !== command.main_period_tip_slug) {
                                let env = this
                                setTimeout(function () {
                                    env.mainSegmentTipSlug = command.main_period_tip_slug
                                    env.playCoachVideoFragment(command.main_period_tip_slug)
                                }, 470)
                            }

                            this.basicTechniqueStrokePercent = command.basic_technique_stroke_percent
                            this.basicTechniqueGoodStrokeCount = command.basic_technique_good_stroke_count
                            this.basicTechniqueTop = command.basic_technique_top

                            this.forwardAnglePos = command.forward_angle_pos
                            this.laybackAnglePos = command.layback_angle_pos
                            this.shinsAnglePos = command.shin_angle_pos

                            if (this.rowerSideEncounterMirror !== this.rowerSide) {
                                this.forwardAnglePos = 1 - this.forwardAnglePos
                                this.laybackAnglePos = 1 - this.laybackAnglePos
                                this.shinsAnglePos = 1 - this.shinsAnglePos
                            }

                            this.laybackAngle = command.layback_angle
                            this.forwardAngle = command.forward_angle
                            this.shinsAngle = command.shin_angle

                            this.driveDuration = command.drive_duration
                            this.recoveryDuration = command.recovery_duration

                            this.analyzedStrokeCount += 1

                            if (this.analyzedStrokeCount % 4 === 1)
                            {
                                this.grabScreenPhotoTimeoutHandle = setTimeout(() => {
                                    this.grabScreenPhoto()
                                }, 1000 + Math.random()*650)
                            }
                        } else if (command.name === 'stroke_count_panel_status') {
                            this.strokeCount = command.stroke_count
                            this.checkedStrokeCountBasicMode = command.checked_stroke_count_basic_mode
                            this.checkedStrokeCountProMode = command.checked_stroke_count_pro_mode
                            this.checkedStrokeCountSynchMode = command.checked_stroke_count_synch_mode
                            this.strokeCountLastRowingPeriod = command.stroke_count_last_rowing_period
                            this.strokeCountInCircle = command.stroke_count_in_circle
                            this.strokeText = command.stroke_text
                            let dataNum = this.strokeCount % this.tableDataStoryPro.length
                            this.tableData = this.rowingTrainingMode === 'pro' ? this.tableDataStoryPro[dataNum] : this.tableDataStory[dataNum]
                        } else if (command.name === 'rowing_start_event') {
                            if (!this.trainingStartedTs)
                                this.setupTimeCounter()
                        } else if (command.name === 'rowing_end_event') {

                        } else if (command.name === 'spm') {
                            this.spm = command.val
                        } else if (command.name === 'max_spm') {
                            this.maxSpm = command.val
                        } else if (command.name === 'set_dropout') {
                            this.clientDropout = command.val
                        }
                        else if (command.name === 'synch_spm') {
                            this.synchSpm = command.val
                        }
                        else if (command.name === 'synch_rowing_technique') {
                            this.synchLaybackAngle = command.layback_angle
                            this.synchForwardAngle = command.forward_angle
                            this.synchShinsAngle = command.shin_angle
                            this.synchLbSeparation = command.lb_separation
                            this.synchBaSeparation = command.ba_separation
                            this.synchDriveDuration = command.drive_duration
                            this.synchRecoveryDuration = command.recovery_duration
                            this.synchStrokeNum = command.stroke_num
                        }
                        else if (command.name === 'synch_spm_metrics') {
                            this.synchSpmMetrics = command.val
                        }
                        else if (command.name === 'synch_rhythm_status') {
                            this.synchCatchDiffMs = command.catch_diff_ms
                            this.synchFinishDiffMs = command.finish_diff_ms
                            this.synchRhythmActorStrokeNum = command.synch_rhythm_actor_stroke_num
                            this.synchRhythmMetrics = command.metrics
                            this.synchRhythmStrokePercent = command.synch_rhythm_stroke_percent
                            this.synchRhythmMatchedStrokeCount = command.synch_rhythm_matched_stroke_count
                            this.synchRhythmTip = command.synch_rhythm_tip
                            if (this.rowingTrainingMode === 'synch' && this.synchRhythmTipSlug !== command.synch_rhythm_tip_slug) {
                                let env = this
                                setTimeout(function () {
                                    env.synchRhythmTipSlug = command.synch_rhythm_tip_slug
                                    env.playCoachVideoFragment(command.synch_rhythm_tip_slug)
                                }, 470)
                            }
                            this.synchRhythmTop = command.synch_rhythm_top
                            this.synchDrivePeriodEnd = command.synch_drive_period_end
                            this.synchActorDrivePeriodEnd = command.synch_actor_drive_period_end
                        }
                        else if (command.name === 'synch_technique_metrics') {
                            this.synchTechniqueMetrics = command.val
                        }
                        else if (command.name === 'poses') {
                            this.drawPoses(command.val, command.rects_contours)
                        }
                        else if (command.name === 'squats') {
                            this.crossfitSquatsCount = command.val
                        }
                        else if (command.name === 'pushups') {
                            this.crossfitPushupsCount = command.val
                        }
                        else if (command.name === 'burpees') {
                            this.crossfitBurpeesCount = command.val
                        }
                        else if (command.name === 'play_crossfit_coach_fragment') {
                            if (command.delay)
                                setTimeout(this.playCoachVideoFragment, command.delay, command.fragment_name)
                            else
                                this.playCoachVideoFragment(command.fragment_name)
                        }
                        else if (command.name === 'reset_rowing_counters_on_client') {
                            this.synchRhythmMatchedStrokeCount = 0
                            this.basicTechniqueGoodStrokeCount = 0
                            this.strokeCount = 0
                            this.strokeCountLastRowingPeriod = 0
                            this.checkedStrokeCountBasicMode = 0
                            this.checkedStrokeCountProMode = 0
                            this.checkedStrokeCountSynchMode = 0
                            this.synchRhythmTop = null
                            this.basicTechniqueTop = null
                            this.synchRhythmStrokePercent = null
                            this.basicTechniqueStrokePercent = null
                            this.trainingStartedTs = performance.now()/1000
                            this.mainSegmentTip = null
                            this.synchRhythmTip = null
                            this.maxSpm = null
                        }
                    }
            },
            sendWebsocketMsg(obj) {
                let msg = JSON.stringify(obj)
                if (this.socket)
                    this.socket.send(msg)
                else {
                    if (this.store.myUser.isSuperuser)
                        console.log(`Message ${msg} wasn't sent due to ws disconnected`)
                    else
                        console.log("Message wasn't sent due to ws disconnected")
                }
            },
            async setupWebrtcToServerVideoTransfer() {
                console.log('WebRTC to server video stream starting')

                let p = new SimplePeer({ initiator: true, stream: this.currentMediaStream, trickle: false, config: {} })
                this.simplePeerToServer = p

                // noinspection JSUnresolvedFunction
                p.on('error', err =>  {
                    console.log('webrtc to server connection error', err.code)
                    this.webrtcToServerConnectionSuccessful = false
                    if (this.trainingStarted)
                        if (this.deviceMode === 'camera_and_display')
                            this.addOnVideoMessage('webrtc_to_server_failed', 'Your firewall restricts video connectivity. Analysis may be inaccurate')
                        else
                            this.addOnVideoMessage('webrtc_to_server_failed', 'Your firewall restricts video connectivity. Analysis failed to start')
                } )

                // noinspection JSUnresolvedFunction
                p.on('signal', data => {
                    this.sendWebsocketMsg({event: 'webrtc_to_server_offer', val: data})

                    let pc = p._pc
                    const [sender] = pc.getSenders();
                    const ratio = sender.track.getSettings().width / this.webrtcSenderWH[0]
                    const params = sender.getParameters()
                    if (!params.encodings) { // for firefox, see
                        // https://stackoverflow.com/questions/57400849/webrtc-change-bandwidth-receiving-invalidmodificationerror-on-chrome
                        params.encodings = [{}]
                    }
                    params.encodings[0].scaleResolutionDownBy = Math.max(ratio, 1)
                    sender.setParameters(params)
                })

                // noinspection JSUnresolvedFunction
                p.on('connect', () => {
                    this.webrtcToServerConnectionSuccessful = true
                })

                while (this.webrtcToServerConnectionSuccessful === null) {
                    await sleep(300)
                    if (!this.trainingStarted)
                        return
                }
                return this.webrtcToServerConnectionSuccessful
            },
            async setupWebrtcToDisplayVideoTransfer() {
                console.log('WebRTC to display video stream starting')
                let p = new SimplePeer({ initiator: true, stream: this.currentMediaStream })
                this.simplePeerToDisplay = p

                // noinspection JSUnresolvedFunction
                p.on('error', err =>  {
                    console.log('webrtc to display connection error', err.code)
                    this.webrtcToDisplayConnectionSuccessful = false
                    if (this.trainingStarted)
                        this.addOnVideoMessage('webrtc_to_display_failed', "Your firewall restricts video connectivity. Can't send videostream")
                } )

                // noinspection JSUnresolvedFunction
                p.on('signal', data => {
                    this.sendWebsocketMsg({event: 'webrtc_to_display_signal', val: data})
                })

                // noinspection JSUnresolvedFunction
                p.on('connect', () => {
                    this.webrtcToDisplayConnectionSuccessful = true
                })

                while (this.webrtcToDisplayConnectionSuccessful === null) {
                    await sleep(300)
                    if (!this.trainingStarted)
                        return
                }
                return this.webrtcToDisplayConnectionSuccessful
            },
            setupWebrtcFromCameraVideoTransfer() {
                let p = new SimplePeer()
                this.simplePeerFromCamera = p

                // noinspection JSUnresolvedFunction
                p.on('error', err =>  {
                    console.log('webrtc from camera connection error', err.code)
                    this.webrtcFromCameraConnectionSuccessful = false
                    if (this.trainingStarted)
                        this.addOnVideoMessage('webrtc_from_camera_failed', "Your firewall restricts video connectivity. Can't receive videostream")
                } )

                // noinspection JSUnresolvedFunction
                p.on('signal', data => {
                    this.sendWebsocketMsg({event: 'webrtc_to_camera_signal', val: data})
                })

                // noinspection JSUnresolvedFunction
                p.on('connect', () => {
                    this.webrtcFromCameraConnectionSuccessful = true
                })

                // noinspection JSUnresolvedFunction
                p.on('stream', stream => {
                    if ('srcObject' in this.videoDom)
                        this.videoDom.srcObject = stream
                    else
                        this.videoDom.src = window.URL.createObjectURL(stream)
                    this.videoDom.play()
                })
            },
            setupWebSocketsVideoTransfer() {
                console.log('Websocket video transfer starting')

                if (!store.myUser.onlineTrainingHideOtherWarnings)
                    this.addOnVideoMessage('websocket_video_transfer', 'Your firewall restricts video connectivity. Quality of service may be low', true)

                this.bufferCanvas = document.getElementById('online-training-buffer')
                this.buffer2dCtx = this.bufferCanvas.getContext('2d', {alpha: false})
                this.bufferCanvas.width = this.canvasSenderWH[0]
                this.bufferCanvas.height = this.canvasSenderWH[1]

                if (this.requestVideoFrameCallbackAvailable)
                    { // noinspection JSUnresolvedFunction
                        this.frameCaptureHandle = this.videoDom.requestVideoFrameCallback(this.runProcessingStep)
                    }
                else
                    this.frameCaptureHandle = setInterval(this.runProcessingStep, 1000/(this.videoFPS*2))
            },
            setupFPS() {
                this.stats = new Stats()
                this.stats.showPanel(0)
                this.stats.dom.id = 'online-training-fps'
                this.stats.dom.style.display = store.showStaffControls ? 'block' : 'none'
                document.getElementsByClassName('main-row')[0].appendChild(this.stats.dom)
            },
            oppositeSide(side) {
                if (side === 'r')
                    return 'l'
                else if (side === 'l')
                    return 'r'
                else
                    return null
            },
            swapShowInCornerIfPossible() {
                if (this.rowingTrainingMode === 'synch') {
                    this.cameraStreamShowInCornerMode = !this.cameraStreamShowInCornerMode
                }
            },
            runSynchVideo(videoBlob) {
                this.synchVideoDom.src = URL.createObjectURL(videoBlob)
                this.deleteOnVideoMessage('synch_video_downloading_failed')
                this.synchVideoDom.onplay = () => {
                    this.synchVideoIsPlaying = true
                    this.sendWebsocketMsg({
                        event: 'commands',
                        commands: [
                            {
                                name: 'set_mode',
                                mode: 'synch',
                                playing: true,
                                video_slug: this.synchVideo,
                                seat: this.synchVideosInfo[this.synchVideo]['multiX'] ? this.synchVideoSeat : null,
                                is_lateral: this.synchVideosInfo[this.synchVideo]['isLateral']
                            }
                        ]
                    })
                }
                this.synchVideoDom.play()
                this.synchVideoDownloadProgress = null
                if (this.webrtcToServerConnectionSuccessful || this.deviceMode === 'display') {
                    let env2 = this
                    this.synchTsSenderHandle = setInterval(function () {
                        let synchTs = env2.synchVideoIsPlaying ? env2.synchVideoDom.currentTime - 0.200 : null
                        env2.sendWebsocketMsg({event: 'commands', commands: [{name: 'set_synch_ts', val: synchTs}]})
                    }, 200)
                }
            },
            async preloadAndRunSynchVideo() {
                let blob = await localForage.getItem(this.synchVideo + 'SynchVideo');
                this.synchVideoDom = document.getElementsByClassName('synch-video')[0]
                this.synchVideoDom.src = null

                if (blob === null) {
                    this.synchVideoRequest = new XMLHttpRequest();
                    this.synchVideoRequest.open('GET', this.synchVideosInfo[this.synchVideo]['src'], true);
                    this.synchVideoRequest.responseType = 'blob';

                    // noinspection ES6ConvertVarToLetConst
                    var env = this
                    this.synchVideoRequest.onload = async function() {
                        if (this.status === 200) {
                            try {
                                await localForage.setItem(env.synchVideo + 'SynchVideo', this.response)
                            }
                            catch {
                                console.log('Cant save video to indexedDB')
                            }
                            env.runSynchVideo(this.response)
                        }
                    }
                    this.synchVideoRequest.onerror = function() {
                        env.addOnVideoMessage('synch_video_downloading_failed', 'Synchronicity video downloading failed')
                        env.synchVideoDownloadProgress = null
                    }

                    this.synchVideoRequest.onprogress = (event) => {
                        this.synchVideoDownloadProgress =  Math.floor(event.loaded/event.total*100)
                    }
                    this.synchVideoRequest.send();
                }
                else {
                    this.runSynchVideo(blob)
                }
            },
            runTrainingVideo(videoBlob) {
                this.synchVideoDom.src = URL.createObjectURL(videoBlob)
                this.deleteOnVideoMessage('training_video_downloading_failed')
                this.synchVideoDom.onplay = () => {
                    this.synchVideoIsPlaying = true
                }
                this.synchVideoDom.play()
                this.synchVideoDownloadProgress = null
            },
            async preloadAndRunTrainingVideo() {
                let blob = await localForage.getItem(this.trainingVideo + 'TrainingVideo');
                this.synchVideoDom = document.getElementsByClassName('synch-video')[0]
                this.synchVideoDom.src = null

                if (blob === null) {
                    this.synchVideoRequest = new XMLHttpRequest();
                    this.synchVideoRequest.open('GET', this.trainingVideosInfo[this.trainingVideo]['src'], true);
                    this.synchVideoRequest.responseType = 'blob';

                    // noinspection ES6ConvertVarToLetConst
                    var env = this
                    this.synchVideoRequest.onload = async function() {
                        if (this.status === 200) {
                            try {
                                await localForage.setItem(env.trainingVideo + 'TrainingVideo', this.response)
                            }
                            catch {
                                console.log('Cant save video to indexedDB')
                            }
                            env.runTrainingVideo(this.response)
                        }
                    }
                    this.synchVideoRequest.onerror = function() {
                        env.addOnVideoMessage('training_video_downloading_failed', 'Training video downloading failed')
                        env.synchVideoDownloadProgress = null
                    }

                    this.synchVideoRequest.onprogress = (event) => {
                        this.synchVideoDownloadProgress =  Math.floor(event.loaded/event.total*100)
                    }
                    this.synchVideoRequest.send();
                }
                else {
                    this.runTrainingVideo(blob)
                }
            },
            preloadCoachVideo() {
                this.coachVideoRequest = new XMLHttpRequest();
                this.coachVideoRequest.open('GET', this.trainingMode === 'rowing' ? require('../assets/online-training-videos/rowing_coach_lq.mp4') : require('../assets/online-training-videos/crossfit_coach.mp4'), true);
                this.coachVideoRequest.responseType = 'blob';
                this.coachVideoDom = document.getElementsByClassName('coach-video')[0]
                this.coachVideoDom.src = null

                // noinspection ES6ConvertVarToLetConst
                var env = this
                this.coachVideoRequest.onload = async function() {
                    if (this.status === 200) {
                        let videoBlob = this.response
                        env.coachVideoDom.src = URL.createObjectURL(videoBlob)
                        env.coachVideoDownloadProgress = null
                        env.coachVideoReady = true
                        if (env.trainingMode === 'rowing') {
                           env.playCoachVideoFragment('intro_move')
                        }
                    }
                }

                this.coachVideoRequest.onerror = function() {
                    env.addOnVideoMessage('coach_video_downloading_failed', 'Coach video downloading failed')
                    env.coachVideoDownloadProgress = null
                }

                this.coachVideoRequest.onprogress = (event) => {
                    this.coachVideoDownloadProgress =  Math.floor(event.loaded/event.total*100)
                }

                this.coachVideoRequest.send();
            },
            setRowerSideEncounterMirror() {
                this.rowerSideEncounterMirror = this.isUserFacingCamera ? this.oppositeSide(this.rowerSide) : this.rowerSide
            },
            onSynchVideoStopped(resetSynchLevel) {
                if (this.synchVideoRequest)
                    this.synchVideoRequest.abort()

                this.synchVideoRequest = null
                this.synchVideoIsPlaying = false
                this.synchVideoDom = null
                this.synchSpm = null
                this.synchLaybackAngle = null
                this.synchForwardAngle = null
                this.synchShinsAngle = null
                this.synchLbSeparation = null
                this.synchBaSeparation = null
                this.synchDriveDuration = null
                this.synchRecoveryDuration = null
                this.synchStrokeNum = null
                this.synchSpmMetrics = 0
                this.synchCatchDiffMs = null
                this.synchFinishDiffMs = null
                this.synchRhythmActorStrokeNum = null
                this.synchRhythmMetrics = 0
                this.synchTechniqueMetrics = 0
                if (resetSynchLevel)
                    this.synchLevel = 1

                if (this.synchTsSenderHandle) {
                    clearInterval(this.synchTsSenderHandle)
                    this.synchTsSenderHandle = null
                }
            },
            wideScreenOn() {
                let cAppDom = document.getElementsByClassName('c-app')[0]
                if (this.isTouchDevice)
                    cAppDom.style['min-width'] = '1800px'
                else
                    cAppDom.style['min-width'] = Math.round(window.screen.availWidth*0.95) + 'px'
                this.$nextTick(async () => {
                    if (this.isTouchDevice) {
                        let viewport = document.querySelector('meta[name=viewport]')
                        viewport.setAttribute('content', 'height=760, maximum-scale=4, minimum-scale=0.2, user-scalable=yes')
                        await sleep(500)
                    }
                    document.getElementById('start-stop-button').scrollIntoView({behavior: 'smooth', block: 'start', inline: 'center'})
                })
            },
            wideScreenOff() {
                if (this.isTouchDevice) {
                    let cAppDom = document.getElementsByClassName('c-app')[0]
                    cAppDom.style.removeProperty('min-width')
                    let viewport = document.querySelector('meta[name=viewport]');
                    viewport.setAttribute('content', 'width=device-width, initial-scale=1')
                }
            },
            setupTrainingConfig (crossfitTrainingConfig) {
                this.crossfitTrainingConfig = crossfitTrainingConfig
                this.crossfitSquatsCountTarget = this.crossfitTrainingConfig['squats']
                this.crossfitPushupsCountTarget = this.crossfitTrainingConfig['pushups']
                this.crossfitBurpeesCountTarget = this.crossfitTrainingConfig['burpees']
            },
            async playCoachVideoFragment(fragment) {
                let fragments

                if (this.trainingMode === 'crossfit')
                    fragments = this.crossfitCoachVideoFragments
                else if (this.trainingMode === 'rowing')
                    fragments = this.rowingCoachVideoFragments

                if (this.coachVideoReady && fragment in fragments && this.coachSwitchFlag) {
                    // noinspection ES6ConvertVarToLetConst
                    var startTime = fragments[fragment][0]
                    // noinspection ES6ConvertVarToLetConst
                    var endTime = fragments[fragment][1]
                    // noinspection ES6ConvertVarToLetConst
                    var env = this

                    function checkTime() {
                        if (env.coachVideoTimeoutHandle !== null) {
                            clearTimeout(env.coachVideoTimeoutHandle)
                            env.coachVideoTimeoutHandle = null
                        }
                        if (env.coachVideoDom.currentTime >= endTime) {
                            env.coachVideoDom.pause();
                        } else {
                            env.coachVideoTimeoutHandle = setTimeout(checkTime, 80);
                        }
                    }

                    this.coachVideoDom.pause()
                    this.coachVideoDom.currentTime = startTime
                    await this.coachVideoDom.play()
                    checkTime()
                }
            },
            setupTimeCounter() {
                if (!this.trainingStartedTs)
                    this.trainingStartedTs = performance.now()/1000
                this.trainingDurationHandle = setInterval(() => {
                    let duration = performance.now()/1000 - this.trainingStartedTs + 1
                    let durationMoment = moment.duration(duration, 'seconds')
                    // noinspection ES6ShorthandObjectProperty
                    this.durationStr = moment.utc(durationMoment.as('milliseconds')).format('HH:mm.ss')
                }, 300)
            },
            rowingFullscreenGuiModeChanged() {
                // let index = (this.rowingModeSwiper.realIndex - 1 + this.rowingModeSwiper.slides.length) % this.rowingModeSwiper.slides.length
                let index = this.rowingModeSwiper.realIndex
                this.rowingTrainingMode = this.rowingModeSwiper.slides[index].getAttribute('data-mode')
            },
            swapElements(obj1, obj2) {
                // save the location of obj2
                // noinspection ES6ConvertVarToLetConst
                var parent2 = obj2.parentNode;
                // noinspection ES6ConvertVarToLetConst
                var next2 = obj2.nextSibling;
                // special case for obj1 is the next sibling of obj2
                if (next2 === obj1) {
                    // just put obj1 before obj2
                    parent2.insertBefore(obj1, obj2);
                } else {
                    // insert obj2 right before obj1
                    obj1.parentNode.insertBefore(obj2, obj1);

                    // now insert obj1 where obj2 was
                    if (next2) {
                        // if there was an element after obj2, then insert obj1 right before that
                        parent2.insertBefore(obj1, next2);
                    } else {
                        // otherwise, just append as last child
                        parent2.appendChild(obj1);
                    }
                }
            },
            swapVideoStreamsRowingFullScreen() {
                let bigVideo = document.getElementsByClassName('online-training-video')[0]
                let bigVideoCanvas = document.getElementsByClassName('online-training-output')[0]
                let smallVideo = document.getElementsByClassName('synch-video')[0]
                let smallVideoCanvas = document.getElementsByClassName('online-training-output-stub')[0]
                let bigVideo_className = bigVideo.className
                let smallVideo_className = smallVideo.className
                smallVideo.className = bigVideo_className
                bigVideo.className = smallVideo_className
                this.swapElements(bigVideo, smallVideo)
                this.swapElements(bigVideoCanvas, smallVideoCanvas)
                this.rowingFullscreenVideoSwapped = !this.rowingFullscreenVideoSwapped
            },
            swapVideoOnClick() {
                if (this.rowingTrainingMode === 'synch' || (this.rowingTrainingMode === 'basic' && this.rowingTrainingVideoInBasicModeVisible)) {
                    this.swapVideoStreamsRowingFullScreen()
                }
            },
            nextTrainingVideo() {
                if (this.rowingFullscreenVideoSwapped)
                    this.swapVideoStreamsRowingFullScreen()
                if (this.rowingTrainingMode === 'synch') {
                    let keys = Object.keys(this.synchVideosInfo);
                    this.synchVideo = keys[(keys.indexOf(this.synchVideo) + 1) % keys.length]
                } else if (this.rowingTrainingMode === 'basic' && this.rowingTrainingVideoInBasicModeVisible) {
                    let keys = Object.keys(this.trainingVideosInfo);
                    this.trainingVideo = keys[(keys.indexOf(this.trainingVideo) + 1) % keys.length]
                }
            },
            prevTrainingVideo() {
                if (this.rowingFullscreenVideoSwapped)
                    this.swapVideoStreamsRowingFullScreen()
                if (this.rowingTrainingMode === 'synch') {
                    let keys = Object.keys(this.synchVideosInfo);
                    this.synchVideo = keys[(keys.indexOf(this.synchVideo) - 1 + keys.length) % keys.length]
                } else if (this.rowingTrainingMode === 'basic' && this.rowingTrainingVideoInBasicModeVisible) {
                    let keys = Object.keys(this.trainingVideosInfo);
                    this.trainingVideo = keys[(keys.indexOf(this.trainingVideo) - 1 + keys.length) % keys.length]
                }

            },
            sendRowingResetCountersCommand() {
                this.sendWebsocketMsg({event: 'commands', commands: [{name: 'reset_rowing_counters_on_server'}]})
                this.rowingFullscreenGuiBurgerActive = false
            },
            showHideTrainingVideo() {
                if (this.rowingFullscreenVideoSwapped)
                    this.swapVideoStreamsRowingFullScreen()
                this.rowingTrainingVideoInBasicModeVisible = !this.rowingTrainingVideoInBasicModeVisible
            },
            async grabScreenPhoto() {
                try {
                    await this.screenCaptureVideoDom.play()
                    while (!(this.screenCaptureVideoDom.currentTime > 0 && !this.screenCaptureVideoDom.paused && !this.screenCaptureVideoDom.ended
                        && this.screenCaptureVideoDom.readyState > this.screenCaptureVideoDom.HAVE_CURRENT_DATA))
                        await sleep(50)
                    await sleep(50)
                }
                catch (e)
                {
                    console.log('grab screen photo issue')
                    console.log(e)
                }
                this.screenCaptureVideoDom.pause()

                this.screenCaptureCanvasDom.getContext('2d').drawImage(this.screenCaptureVideoDom, 0, 0, this.screenCaptureStreamWH[0], this.screenCaptureStreamWH[1], 0, 0, this.sceenPhotoUploadingWidth, this.sceenPhotoUploadingHeight);
                this.screenCaptureCanvasDom.toBlob(async blob => {
                    // console.log('output blob:', blob);
                    await this.uploadScreenPhoto(blob)
                }, 'image/jpeg', 0.9);
            },
            async uploadScreenPhoto(blob) {
                let response
                try {
                    if (this.sceenPhotoUploadingAxiosCancelTokenSource)
                        this.sceenPhotoUploadingAxiosCancelTokenSource.cancel()

                    this.sceenPhotoUploadingAxiosCancelTokenSource = axios.CancelToken.source()

                    let data = new FormData()
                    data.append('file', blob, 'online_training_exhibition_photo.jpg')

                    response = await axios.post(backendURL + '/files/',
                        data,
                        {
                            cancelToken: this.sceenPhotoUploadingAxiosCancelTokenSource.token,
                            headers: { 'Content-Type' : 'multipart/form-data' },
                            withCredentials: true
                        })
                    this.sceenPhotoUploadingAxiosCancelTokenSource = null
                } catch (e) {
                    if (!axios.isCancel(e)) {
                        throw e
                    } else {
                        console.log('screen photo uploading canceled due to next started to upload')
                    }
                }

                let uploadedFileId = response.data['file_id']
                if (!uploadedFileId) {
                    throw Error("Server hasn't returned file id")
                }
                let mutation = gql`
                        mutation {
                                    addOnlineTrainingExhibitionPhoto(fileId: ${uploadedFileId}) {
                                        success
                                    }
                                }`
                await apolloClient.mutate({
                    mutation
                })
            }


        },
        computed: {
            fullScreenFlag() {
                return (this.trainingMode === 'crossfit' || this.rowingTrainingMode === 'synch' || this.deviceMode === 'camera')
            }
        },
        watch: {
            'store.showStaffControls': function (newVal) {
                if (this.stats)
                    this.stats.dom.style.display = newVal ? 'block' : 'none'
            },
            debugShowPosesAllTimeFlag: function (newVal) {
                if (this.trainingStarted) {
                    this.sendWebsocketMsg({event: 'commands', commands: [{name: 'set_debug_show_pose_all_time_flag', val: newVal}]})
                }
            },
            'rowingTrainingMode': function (newVal, oldVal) {
                if (this.trainingStarted) {
                    this.cameraStreamShowInCornerMode = false
                    // noinspection RedundantIfStatementJS
                    if (this.rowingIsFullscreenFlag) {
                        // noinspection RedundantIfStatementJS
                        if (newVal !== 'pro')
                            this.coachSwitchFlag = true
                        else
                            this.coachSwitchFlag = false
                        if (this.rowingFullscreenVideoSwapped)
                            this.swapVideoStreamsRowingFullScreen()
                    }
                    else
                        if (newVal === 'synch')
                            this.coachSwitchFlag = false

                    this.deleteOnVideoMessage('synch_video_downloading_failed')
                    if (oldVal === 'synch' || (oldVal === 'basic' && this.rowingTrainingVideoInBasicModeVisible))
                        this.onSynchVideoStopped()
                    if (newVal === 'basic' && this.rowingTrainingVideoInBasicModeVisible) {
                        this.$nextTick(this.preloadAndRunTrainingVideo)
                    }
                    if (newVal === 'synch') {
                        this.sendWebsocketMsg({event: 'commands', commands: [{name: 'set_mode', mode: newVal, playing: false}]})
                        this.$nextTick(this.preloadAndRunSynchVideo)
                    }
                    else
                        this.sendWebsocketMsg({event: 'commands', commands: [{name: 'set_mode', mode: newVal}]})
                }
            },
            'rowingTrainingVideoInBasicModeVisible' : function (newVal) {
                if (newVal === true) {
                    this.$nextTick(this.preloadAndRunTrainingVideo)
                }
                else {
                    this.onSynchVideoStopped()
                }
            },
            'synchVideo': function (newVal) {
                if (this.trainingStarted) {
                    this.onSynchVideoStopped(this.synchVideosInfo[newVal].isLateral)
                    this.preloadAndRunSynchVideo()
                }
            },
            'trainingVideo': function () {
                if (this.trainingStarted) {
                    this.onSynchVideoStopped()
                    this.preloadAndRunTrainingVideo()
                }
            },
            'synchVideoSeat': function () {
                if (this.trainingStarted) {
                    this.onSynchVideoStopped(false)
                    this.preloadAndRunSynchVideo()
                }
            },
            'isUserFacingCamera': function () {
                if (this.trainingStarted) {
                    this.setRowerSideEncounterMirror()
                }
            },
            'deviceMode' : function (newVal) {
                if (newVal === 'display') {
                    this.isCameraDevice = false
                    this.isDisplayDevice = true
                } else if (newVal === 'camera') {
                    this.isCameraDevice = true
                    this.isDisplayDevice = false
                    this.trainingMode = null
                    this.coachSwitchFlag = false
                    this.startStopTraining()
                } else if (newVal === 'camera_and_display') {
                    this.isCameraDevice = true
                    this.isDisplayDevice = true
                }
            },
            'webrtcToServerConnectionSuccessful': function (newval) {
                if ((newval && this.webrtcToDisplayConnectionSuccessful) || !newval) {
                    this.deleteOnVideoMessage('connecting')
                    this.showSpinnerOnVideo = false
                }
            },
            'webrtcToDisplayConnectionSuccessful': function (newval) {
                if ((newval && this.webrtcToServerConnectionSuccessful) || !newval)
                    this.deleteOnVideoMessage('connecting')
                    this.showSpinnerOnVideo = false
            },
            'webrtcFromCameraConnectionSuccessful': function () {
                this.deleteOnVideoMessage('connecting')
                this.showSpinnerOnVideo = false
            },
            'readyForVideoStream': function (newVal) {
                if (this.trainingMode === 'rowing' && this.store.myUser.onlineTrainingEnableFullscreenRowing && this.trainingStarted)
                    this.rowingIsFullscreenFlag = newVal
            },
            'isLandscapeOrientation': function (newVal) {
                if (this.trainingMode === 'rowing' && this.store.myUser.onlineTrainingEnableFullscreenRowing && this.trainingStarted && !newVal && this.rowingIsFullscreenFlag)
                    this.rowingIsFullscreenFlag = false
            },
            'rowingIsFullscreenFlag': function (newVal) {
                let cApp = document.getElementsByClassName('c-app')[0]
                let body = document.getElementsByTagName('body')[0]
                let cHeader = document.getElementsByClassName('c-header')[0]
                let cFooter = document.getElementsByClassName('c-footer')[0]
                if (newVal === true) {
                    cApp.style.background = 'rgba(0,0,0,0)'
                    body.style.background = 'rgba(0,0,0,0)'
                    cHeader.style.visibility = 'hidden'
                    cFooter.style.visibility = 'hidden'
                }
                else {
                    cApp.style.visibility = '#ebedef'
                    body.style.background = '#ebedef'
                    cHeader.style.visibility = 'visible'
                    cFooter.style.visibility = 'visible'
                }
            },
            // 'strokeCountLastRowingPeriod': function (newVal) {
            //     if (newVal === 0) {
            //         this.addOnVideoMessage('start_rowing', 'Start rowing!', true)
            //     }
            //     if (newVal === 1) {
            //         this.deleteOnVideoMessage('start_rowing')
            //     }
            // }
        },
        mounted() {
            if (this.isTouchDevice) {
                let setIsLandscapeOrientation = () => {
                    this.isLandscapeOrientation = window.innerWidth > window.innerHeight
                    if (this.readyForVideoStream)
                        if (this.isLandscapeOrientation)
                            this.wideScreenOn()
                        else
                            this.wideScreenOff()
                }
                setIsLandscapeOrientation()
                window.addEventListener('resize', setIsLandscapeOrientation)
            }
            else {
                const updatePixelRatio = () => {
                    let pr = window.devicePixelRatio
                    if (this.readyForVideoStream)
                        document.getElementById('start-stop-button').scrollIntoView({behavior: 'smooth', block: 'start', inline: 'center'})
                    matchMedia(`(resolution: ${pr}dppx)`).addEventListener("change", updatePixelRatio, { once: true })
                }
                updatePixelRatio();
            }
        },
        beforeDestroy() {
            this.stopTraining()
        }
    }
</script>

<style scoped lang="scss">
    .mt-10 {
        margin-top: 100px
    }

    .mt-5 {
        margin-top: 50px
    }

    .mb-10 {
        margin-bottom: 100px
    }

    .numberCircle {
        width: 86px;
        line-height: 80px;
        border-radius: 50%;
        text-align: center;
        border: 2px solid #666;
    }




    :root {
        --fbl: "Lato-Black", sans-serif
    }
    
    @font-face {
        font-family: Lato-Black;
        src: url('~@/assets/fonts/Lato-Black.woff2') format("woff2");
        font-weight: 900;
        font-display: swap;
        font-style: normal
    }
    *,
    ::after,
    ::before {
        -webkit-box-sizing: border-box;
        box-sizing: border-box
    }
    * {
        margin: 0
    }
    body,
    html {
        height: 100%
    }
    body {
        line-height: 1
    }
    canvas,
    img,
    picture,
    svg,
    video {
        display: block;
        max-width: 100%
    }
    button,
    input,
    select,
    textarea {
        font: inherit
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p {
        overflow-wrap: break-word
    }
    .js-focus-visible :focus:not(.focus-visible) {
        outline: 0
    }
    .js-focus-visible .focus-visible {
        outline: 2px solid #000;
        border-radius: 2px
    }
    a,
    a:visited {
        text-decoration: none
    }
    button {
        cursor: pointer
    }
    .btn-reset {
        border: none;
        padding: 0;
        background: 0 0;
        cursor: pointer
    }
    .list-reset {
        list-style: none;
        margin: 0;
        padding: 0
    }
    body {
        color: #000;
        font-size: 16px;
        background-color: #ccc;
        font-family: Arial,"Helvetica Neue",Helvetica,sans-serif
    }
    body.lock {
        overflow: hidden
    }
    .wrapper {
        width: 100%;
        min-height: 100%;
        overflow: hidden;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column
    }
    .page {
        -webkit-box-flex: 1;
        -ms-flex: 1 1 auto;
        flex: 1 1 auto;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column
    }
    .container {
        max-width: 1920px;
        margin: 0 auto;
        width: 100%;
        padding: 0 28px
    }
    .video {
        position: relative;
        overflow: hidden
    }
    .video embed,
    .video iframe,
    .video object,
    .video video {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%,-50%);
        -ms-transform: translate(-50%,-50%);
        transform: translate(-50%,-50%);
        width: 100%;
        height: 100%;
        -o-object-fit: cover;
        object-fit: cover;
        cursor: pointer
    }
    .header {
        position: relative;
        padding: 32px 0 32px 0;
        left: 0;
        top: 0;
        width: 100%
    }
    .header__content {
        padding-right: 600px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center
    }
    .header__content.right {
        padding-right: 28px;
        padding-left: 600px
    }
    .header__content.right .timer {
        -webkit-box-ordinal-group: 0;
        -ms-flex-order: -1;
        order: -1;
        //noinspection CssReplaceWithShorthandSafely
        margin: 0 26px 0 0;
        //noinspection CssReplaceWithShorthandSafely
        margin-left: auto
    }
    .header__content.right .menu-icon {
        margin: 0
    }
    .header__content.right .menu {
        left: auto;
        right: 28px
    }
    .header__menu-icon {
        margin: 0 53px 0 0
    }
    .timer {
        font-family: var(--fbl);
        font-size: 40px;
        line-height: 48px;
        color: #fff
    }
    .menu {
        margin-top: 10px;
        width: 430px;
        height: 0;
        position: absolute;
        left: 28px;
        top: 82px;
        background: rgba(26,26,26,.3);
        border-radius: 5px;
        padding: 0 26px;
        -webkit-transition: all .3s;
        -o-transition: all .3s;
        transition: all .3s;
        overflow: hidden
    }
    .menu__list li:nth-child(1) {
        padding-top: 8px
    }
    .menu__list li:last-child {
        padding-bottom: 8px
    }
    .menu__link {
        display: block;
        padding: 4px 20px;
        color: #fff;
        font-size: 25px;
        line-height: 30px;
        font-weight: 900;
        text-transform: uppercase
    }
    .menu-icon {
        display: block;
        position: relative;
        width: 50px;
        height: 30px;
        cursor: pointer;
        z-index: 5
    }
    .menu-icon span {
        -webkit-transition: all .3s ease 0s;
        -o-transition: all .3s ease 0s;
        transition: all .3s ease 0s;
        top: calc(50% - 2px);
        left: 0;
        position: absolute;
        width: 100%;
        height: 4px;
        background-color: #fff
    }
    .menu-icon span:first-child {
        top: 0
    }
    .menu-icon span:last-child {
        top: auto;
        bottom: 0
    }
    .menu-icon.active2 span {
        -webkit-transform: scale(0);
        -ms-transform: scale(0);
        transform: scale(0)
    }
    .menu-icon.active2 span:first-child {
        -webkit-transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
        transform: rotate(-45deg);
        top: calc(50% - 2px)
    }
    .menu-icon.active2 span:last-child {
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
        bottom: calc(50% - 2px)
    }
    .footer {
        padding-top: 25px;
        padding-bottom: 20px;
        background: rgba(20, 20, 20,.35)
    }
    .footer__content {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between
    }
    .footer__down {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        padding: 20px 0 0 50px;
        max-width: 55%
    }
    .footer__progress {
        max-width: 620px;
        width: 100%;
        margin: 0 auto
    }
    .footer__progressbar:not(:last-child) {
        margin: 0 0 34px 0
    }
    .left-video-and-text {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 245px;
        flex: 0 0 245px;
        margin: 0 28px 0 0;
        position: relative
    }
    .footer-video {
        background: rgba(26,26,26,.6);
        border-radius: 20px;
        display: none
    }
    .footer-video:before {
        content: "";
        display: block;
        padding-bottom: 71%
    }
    .footer-video__muted {
        position: absolute;
        bottom: 12px;
        right: 12px;
        display: block;
        width: 20px;
        height: 20px;
    }
    .footer-left-text {
        position: relative;
        overflow: hidden;
        display: none
    }
    .footer-left-text.active2 {
        display: block
    }
    .footer-left-text:before {
        content: "";
        display: block;
        padding-bottom: 71%
    }
    .footer-left-text__content {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%,-50%);
        -ms-transform: translate(-50%,-50%);
        transform: translate(-50%,-50%);
        width: 100%;
        height: 100%;
        -o-object-fit: cover;
        object-fit: cover;
        background: rgba(26,26,26,.2);
        border-radius: 20px;
        font-size: 30px;
        line-height: 38px;
        color: #fff;
        font-family: var(--fbl);
        text-align: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 0 10px
    }
    .footer-left-text__btn {
        position: absolute;
        bottom: 12px;
        right: 12px;
        display: block;
        width: 20px;
        height: 20px;
    }
    .comparison__text {
        color: #fff;
        font-size: 22px;
        line-height: 26px;
        font-family: var(--fbl);
        text-transform: uppercase
    }
    .comparison__text--left {
        text-align: right
    }
    .comparison__num {
        color: #fff;
        font-size: 64px;
        line-height: 86px;
        font-family: var(--fbl);
        text-transform: uppercase
    }
    .right-data {
        display: -ms-grid;
        display: grid;
        grid-template-columns: repeat(3,1fr);
        gap: 40px;
        max-width: 435px;
        width: 100%
    }
    .right-data-item__num {
        color: #fff;
        font-size: 64px;
        line-height: 86px;
        font-family: var(--fbl);
        text-align: center
    }
    .right-data-item__text {
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        color: #fff;
        font-family: var(--fbl);
        padding: 0 5px
    }
    .right-data-item-slider {
        max-width: 120px
    }
    .right-data-item-slider__slide {
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        color: #fff;
        font-family: var(--fbl);
        padding: 0 5px
    }
    .right-data-item-slider__nav {
        width: 5px;
        height: 100%;
        background: #000;
        position: absolute;
        top: 50%;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        z-index: 3;
        background: url('~@/assets/img/arrow.svg') center center/contain no-repeat;

    }
    .right-data-item-slider__prev {
        left: 0
    }
    .right-data-item-slider__next {
        right: 0;
        -webkit-transform: translateY(-50%) rotate(180deg);
        -ms-transform: translateY(-50%) rotate(180deg);
        transform: translateY(-50%) rotate(180deg)
    }
    .down-block {
        font-size: 25px;
        line-height: 30px;
        text-align: center;
        color: #cacaca;
        padding: 0 41px
    }
    .progresses {
        -webkit-transform: translateY(5px);
        -ms-transform: translateY(5px);
        transform: translateY(5px);
    }
    .progressbar {
        background: rgba(26,26,26,.2);
        height: 50px;
        position: relative;
        border-radius: 10px
    }
    .progressbar__line {
        position: absolute;
        background: #fff;
        border-radius: 10px;
        top: 0;
        display: block;
        height: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        text-align: center;
        font-size: 30px;
        line-height: 38px;
        color: #000;
        font-family: var(--fbl);
        -webkit-transition: all .3s;
        -o-transition: all .3s;
        transition: all .3s
    }
    .progressbar__green-line {
        position: absolute;
        top: 0;
        height: 100%;
        border: 4px dashed #41e741;
        border-radius: 10px;
        -webkit-transition: all .3s;
        -o-transition: all .3s;
        transition: all .3s
    }
    .double-progressbar {
        height: 50px;
        max-width: 660px;
        width: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        position: relative;
        -webkit-transform: translateY(5px);
        -ms-transform: translateY(5px);
        transform: translateY(5px);
        overflow: hidden;
        border-radius: 10px
    }
    .double-progressbar__white {
        position: relative;
        background: #fff;
        font-size: 30px;
        line-height: 38px;
        color: #000;
        font-family: var(--fbl);
        -webkit-box-flex: 0;
        //-ms-flex: 0 0 calc(65% - 0px);
        //flex: 0 0 calc(65% - 0px);
        margin-left: 0;
        text-align: center;
        padding: 0 5px;
        -webkit-transition: all .3s;
        -o-transition: all .3s;
        transition: all .3s;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center
    }
    .double-progressbar__white-text {
        font-size: 25px;
        line-height: 30px;
        text-align: center;
        color: #cacaca;
        position: absolute;
        top: 105%;
        left: 0;
        width: 100%
    }
    .double-progressbar__dark {
        position: relative;
        background: rgba(26,26,26,.4);
        font-size: 30px;
        line-height: 38px;
        color: #fff;
        font-family: var(--fbl);
        -webkit-box-flex: 1;
        -ms-flex: 1 1 auto;
        flex: 1 1 auto;
        text-align: center;
        padding: 0 5px;
        -webkit-transition: all .3s;
        -o-transition: all .3s;
        transition: all .3s;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center
    }
    .double-progressbar__dark-text {
        font-size: 25px;
        line-height: 30px;
        text-align: center;
        color: #cacaca;
        position: absolute;
        top: 105%;
        left: 0;
        width: 100%
    }
    .double-progressbar__green-line {
        position: absolute;
        top: 0;
        height: 100%;
        border: 4px dashed #41e741;
        border-radius: 10px;
        left: 0;
        -webkit-transition: all .3s;
        -o-transition: all .3s;
        transition: all .3s;
        z-index: 2
    }
    .body-bg {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: -1
    }
    .body-bg__video {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        -o-object-fit: cover;
        object-fit: cover;
        display: block;
        background-color: black;
    }
    .preload {
        height: 60px;
        width: 60px;
        //noinspection CssOverwrittenProperties
        position: relative;
        //noinspection CssOverwrittenProperties
        position: fixed;
        top: 30%;
        left: 50%;
        -webkit-transform: translate(-50%,-50%);
        -ms-transform: translate(-50%,-50%);
        transform: translate(-50%,-50%);
        z-index: 100;
        font-weight: bold
    }

    .preload2 {
        height: 60px;
        width: 60px;
        //noinspection CssOverwrittenProperties
        position: relative;
        //noinspection CssOverwrittenProperties
        position: fixed;
        top: 55%;
        left: 93%;
        -webkit-transform: translate(-50%,-50%);
        -ms-transform: translate(-50%,-50%);
        transform: translate(-50%,-50%);
        z-index: 100;
    }

    .preload__text {
        position: absolute;
        width: 620px;
        //noinspection CssOverwrittenProperties
        left: 0;
        bottom: 100%;
        //noinspection CssOverwrittenProperties
        left: 50%;
        -webkit-transform: translate(-50%,-10px);
        -ms-transform: translate(-50%,-10px);
        transform: translate(-50%,-10px);
        text-align: center;
        font-size: 20px;
        font-family: var(--fbl);
        color: red
    }
    .green_preload__text {
        color: green
    }
    .preload__bounce1,
    .preload__bounce2 {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background-color: #fff;
        opacity: .6;
        position: absolute;
        top: 0;
        left: 0;
        -webkit-animation: bounce 2s infinite ease-in-out;
        animation: bounce 2s infinite ease-in-out
    }
    .preload__bounce2 {
        -webkit-animation-delay: -1s;
        animation-delay: -1s
    }
    @-webkit-keyframes bounce {
        0%,
        100% {
            transform: scale(0);
            -webkit-transform: scale(0)
        }
        50% {
            transform: scale(1);
            -webkit-transform: scale(1)
        }
    }
    @keyframes bounce {
        0%,
        100% {
            transform: scale(0);
            -webkit-transform: scale(0)
        }
        50% {
            transform: scale(1);
            -webkit-transform: scale(1)
        }
    }
    .slider {
        max-width: 520px;
        width: 100%;
        margin-left: auto;
        position: absolute;
        right: 24px;
        top: 24px
    }
    .slider.left {
        right: auto;
        left: 24px
    }
    .slider__slide {
        background: #6a6969;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        color: #fff;
        border-radius: 20px;
        padding-bottom: 56.25%
    }
    .slider__slide embed,
    .slider__slide iframe,
    .slider__slide object,
    .slider__slide video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        -o-object-fit: cover;
        object-fit: cover;
        border-radius: 20px;
        cursor: pointer
    }
    .slider__pagination .swiper-pagination-bullet {
        background: rgba(196,196,196,.2);
        height: 10px;
        width: 10px
    }
    .slider__pagination .swiper-pagination-bullet-active {
        background: #c4c4c4
    }
    .row2 {
        margin-top: auto;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between
    }
    .row-block {
        width: 100%;
        max-width: 520px;
        background: rgba(26,26,26,.35);
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        padding: 6px 34px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        position: relative
    }
    .row-block-transparent {
        width: 100%;
        max-width: 520px;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        padding: 6px 34px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        position: relative
    }
    .row-block:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 34px;
        right: 34px;
        height: 1px;
        background: #fff
    }


    .row-block-right {
        margin-left: auto
    }
    .row-slider {
        max-width: 225px
    }
    .row-slider__slide {
        padding: 0 5px;
        color: #fff;
        font-size: 30px;
        line-height: 38px;
        font-family: var(--fbl);
        text-align: center;
        text-transform: uppercase
    }
    .row-slider__nav {
        width: 5px;
        height: 100%;
        background: #000;
        position: absolute;
        top: 50%;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        z-index: 3;
        background: url('~@/assets/img/arrow.svg') center center/contain no-repeat
    }
    .row-slider__prev {
        left: 0
    }
    .row-slider__next {
        right: 0;
        -webkit-transform: translateY(-50%) rotate(180deg);
        -ms-transform: translateY(-50%) rotate(180deg);
        transform: translateY(-50%) rotate(180deg)
    }
    .row-text {
        color: #fff;
        font-size: 30px;
        line-height: 38px;
        font-family: var(--fbl);
        text-align: center;
        margin: 0 auto;
        text-transform: uppercase;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center
    }
    .full {
        width: 150px;
        margin-top: 250px
    }

</style>

<!--suppress CssUnusedSymbol -->
<style>
    .spinner-white > .sk-chase-dot:before {
        background-color: rgba(255, 255, 255, 0.6) !important;
    }

    .activity-radio .custom-radio {
        margin: 0 20px 0 20px!important;
    }

    .synch-video {
        background-color: black;
        background-size: 64px 64px;
        background-image: url('~@/assets/img/spinner-black.gif');
        background-repeat: no-repeat;
        background-position: center;
    }
</style>

<!--suppress CssInvalidPseudoSelector, CssUnusedSymbol -->
<style>
    .flelectron:not(:root):fullscreen::backdrop {
        background: rgba(0,0,0,0);
    }
</style>